import { hrTranslations } from "./hr";

const translations = {
  en: {
    // General
    store_name: "AR POS SYSTEM",
    store_tag: "SHOPPING",
    sign_in: "Sign In",
    signing_in: "Signing in...",
    welcome_back: "Welcome back",
    enter_credentials: "Enter your staff number and access code to continue.",
    staff_number: "Staff Number",
    access_code: "Access Code",
    ask_manager: "Ask your manager for login credentials",
    logout: "Log out",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    update: "Update",
    search: "Search",
    loading: "Loading...",
    load_failed_title: "Couldn't load this data — your records are safe, the server didn't answer.",
    inv_load_failed: "Couldn't load products — your data is safe, the server didn't answer.",
    saving: "Saving...",
    done: "Done",
    back: "Back",
    add: "Add",
    remove: "Remove",
    close: "Close",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    actions: "Actions",
    active: "Active",
    inactive: "Inactive",
    all: "All",
    none: "None",
    // Stock source picker (wholesale / mixed carton)
    ss_title: "Where is this stock coming from?",
    ss_desc: "Wholesale / mixed-carton sale — every item will be deducted from the location you choose. Need / available shown per product.",
    ss_store: "Store Stock",
    ss_warehouse: "Warehouse Stock",
    ss_no_location: "No such location in this branch",
    ss_short: "short",
    ss_not_enough: "Not enough stock in",
    ss_need: "need",
    ss_available: "available",
    ss_hint_change: "Choose the other location or adjust the quantities in the cart.",
    ss_back: "Back to cart",
    ss_use: "Use",
    ss_select: "Select a source",
    ss_source: "Stock source",
    ss_change: "Change",
    ss_stock: "stock",
    ss_cartons: "ctn",
    // Nav
    nav_dashboard: "Dashboard",
    nav_more: "Menu",
    name: "Name",
    wao_auto_sent: "WhatsApp update sent to the customer automatically",
    nav_pos: "Point of Sale",
    nav_inventory: "Inventory",
    nav_shipments: "Shipments",
    nav_loyalty: "Loyalty",
    nav_customers: "Customers",
    nav_staff: "Staff",
    nav_reports: "Reports",
    nav_audit: "Audit Log",
    nav_website: "Website Sync",
    nav_branding: "Branding",
    nav_settings: "Settings",
    light_mode: "Light Mode",
    dark_mode: "Dark Mode",
    pin_sidebar: "Pin sidebar",
    auto_hide: "Auto-hide sidebar",
    nav_shop: "Online Shop",
    nav_catalog: "Catalog",
    nav_shop_customizer: "Customize Shop",
    nav_orders: "Orders",
    nav_returns: "Returns & Exchanges",
    nav_wa_orders: "WhatsApp Orders",
    nav_whatsapp: "WhatsApp",
    nav_coupons: "Coupons",
    nav_social: "Social Media",
    nav_vendors: "Vendors",
    nav_analytics: "Analytics",
    nav_stores: "Multi-Store",
    nav_messages: "Messages",
    // Dashboard
    good_morning: "Good morning",
    good_afternoon: "Good afternoon",
    good_evening: "Good evening",
    whats_happening: "Here's what's happening at the store today.",
    todays_revenue: "Today's Revenue",
    todays_sales: "Today's Sales",
    total_products: "Total Products",
    low_stock_items: "Low Stock Items",
    weekly_revenue: "Weekly Revenue",
    recent_sales: "Recent Sales",
    no_recent_sales: "No recent sales",
    no_sales_data: "No sales data yet. Start selling!",
    items: "items",
    item: "item",
    // POS
    cart: "Cart",
    checkout: "Checkout",
    cancel_sale: "Cancel Sale",
    payment_method: "Payment method",
    cash: "Cash",
    card: "Card",
    subtotal: "Subtotal",
    discount: "Discount",
    total: "Total",
    search_products: "Search products, SKU, or barcode...",
    out_of_stock: "Out",
    cart_empty: "Cart is empty",
    no_products: "No products found",
    link_loyalty: "Link loyalty customer",
    sale_completed: "Sale completed!",
    failed_sale: "Failed to process sale",
    open_drawer_first: "Open the cash drawer first",
    each: "each",
    // Cash Drawer
    drawer_open: "Open",
    drawer_closed: "Closed",
    open_cash_drawer: "Open Cash Drawer",
    close_drawer: "Close Drawer",
    drawer_closed_msg: "Drawer is closed. Open it to start selling.",
    opening_amount: "Opening Amount",
    closing_count: "Actual Count",
    expected_balance: "Expected Balance",
    variance: "Variance",
    usd_balance: "USD Balance",
    lbp_balance: "LBP Balance",
    opened_by: "Opened by",
    // Cancel Sale
    cancel_sale_title: "Cancel Sale",
    cancel_sale_desc: "Manager or owner authorization required to cancel the current sale.",
    manager_staff_number: "Manager/Owner Staff Number",
    cancel_confirm: "Cancel Sale",
    verifying: "Verifying...",
    invalid_credentials: "Invalid credentials",
    only_managers: "Only managers or owners can cancel sales",
    // Shift Summary
    shift_summary: "Shift Summary",
    total_sales_count: "Total Sales",
    cash_sales: "Cash Sales",
    card_sales: "Card Sales",
    total_revenue: "Total Revenue",
    cash_drawer_breakdown: "Cash Drawer Breakdown",
    opening: "Opening",
    sales_added: "+ Sales",
    removed: "- Removed",
    expected: "Expected",
    counted: "Counted",
    transactions: "drawer transactions",
    // Inventory
    inventory: "Inventory",
    products_count: "products",
    add_product: "Add Product",
    import_csv: "Import CSV",
    edit_product: "Edit Product",
    product_name: "Product Name",
    price: "Price",
    cost_price: "Cost Price",
    category: "Category",
    stock: "Stock",
    barcode: "Barcode",
    sku: "SKU",
    description: "Description",
    low_stock_alert: "Low Stock Alert",
    product_image: "Product Image",
    upload_image: "Click to upload image",
    paste_url: "Or paste image URL",
    in_stock: "in stock",
    low: "Low",
    out: "Out of Stock",
    deactivate: "Deactivate",
    sku_auto: "Auto-generated",
    all_categories: "All Categories",
    csv_format: "CSV Format Example:",
    import_products: "Import Products",
    // Staff
    staff_management: "Staff Management",
    team_members: "team members",
    edit_staff: "Edit Staff",
    full_name: "Full Name",
    role: "Role",
    admin: "Admin",
    manager: "Manager",
    staff: "Staff",
    new_code: "New Code (optional)",
    code_required: "Access Code",
    leave_blank: "Leave blank to keep current",
    // Loyalty
    loyalty_program: "Loyalty Program",
    manage_loyalty: "Manage customers, loyalty cards, and reward points",
    add_customer: "Add Customer",
    edit_customer: "Edit Customer",
    total_members: "Total Members",
    active_points: "Active Points",
    total_spent: "Total Revenue",
    avg_visits: "Avg Visits",
    phone: "Phone",
    email: "Email",
    loyalty_card: "Loyalty Card",
    loyalty_barcode: "Loyalty Card Barcode",
    barcode_auto: "Auto-generated if left blank",
    points: "pts",
    visits: "Visits",
    add_to_start: "Add customers to start the loyalty program",
    how_points_work: "How loyalty points work:",
    earn_rule: "Customers earn 1 point per $1 spent",
    redeem_rule: "Points can be redeemed at checkout: 100 points = $2 discount",
    link_at_pos: "Link customers at the POS to automatically track points",
    redeem: "Redeem",
    points_min: "Points (min 100)",
    no_contact: "No contact",
    no_card: "No card",
    // Reports
    sales_reports: "Sales Reports",
    track_performance: "Track your store performance",
    this_week: "This Week",
    this_period: "This Period",
    revenue_over_time: "Revenue Over Time",
    by_category: "By Category",
    top_selling: "Top Selling Products",
    units_sold: "units sold",
    days_7: "7 Days",
    days_30: "30 Days",
    days_90: "90 Days",
    no_data_period: "No sales data for this period",
    no_category_data: "No category data",
    no_sales_yet: "No sales data yet",
    // Messages
    messages: "Messages",
    team_communication: "Team communication",
    team_chat: "Team Chat",
    members: "members",
    no_messages: "No messages yet. Start a conversation!",
    type_message: "Type a message...",
    everyone: "Everyone",
    to_everyone: "(to everyone)",
    send: "Send",
    // Settings
    settings: "Settings",
    store_config: "Store configuration and management",
    store_configuration: "Store Configuration",
    store_name_label: "Store Name",
    exchange_rate: "Exchange Rate (1 USD = ? LBP)",
    loyalty_rate: "Loyalty Rate ($ per point)",
    store_logo: "Store Logo",
    upload_logo: "Upload New Logo",
    save_settings: "Save Settings",
    pos_stations: "POS Stations",
    station_desc: "Each device/register can be assigned a station name. Cash drawers are tracked per station.",
    this_device: "This Device",
    all_stations: "All Stations",
    set_active: "Set as Active",
    add_station: "Add",
    station_placeholder: "e.g. Register 2, Front Counter...",
    backup_reset: "Backup & Reset",
    download_backup: "Download Full Backup",
    reset_data: "Reset Data",
    set_reset_pw: "Set Reset Password",
    backup_note: "Backups include all data. Reset requires the owner PIN and the reset password you created.",
    select_reset: "Select what to reset. This action cannot be undone.",
    reset_password: "Reset Password",
    enter_reset_pw: "Enter reset password",
    reset_selected: "Reset Selected Data",
    new_reset_pw: "New Reset Password",
    owner_pw_desc: "Owner-only password required for data reset.",
    min_4_chars: "Min 4 characters",
    save_password: "Save Password",
    products_inventory: "Products & Inventory",
    sales_history: "Sales History",
    customers_loyalty: "Customers & Loyalty",
    audit_log: "Audit Log",
    cash_drawer_history: "Cash Drawer History",
    // Audit Log
    audit_log_title: "Audit Log",
    track_changes: "Track all inventory and system changes",
    all_changes: "All Changes",
    products_filter: "Products",
    settings_filter: "Settings",
    system_filter: "System",
    time: "Time",
    action: "Action",
    changes: "Changes",
    by: "By",
    no_audit: "No audit entries yet",
    // Website Sync
    website_sync: "Website Sync",
    connect_website: "Connect your website to sync products, stock, and prices",
    api_key: "API Key",
    no_key: "No API key generated yet.",
    generate_key: "Generate API Key",
    regenerate_key: "Regenerate Key",
    keep_secret: "Keep this key secret. Only share with your website developer.",
    api_endpoints: "API Endpoints",
    api_desc: "Use these endpoints on your website to fetch and update product data.",
    get_products: "Get All Products",
    update_product: "Update Product",
    connection_status: "Connection Status",
    key_active: "API key active - ready to connect",
    no_key_generated: "No API key generated",
    copied: "Copied to clipboard",
    // Receipt
    sale_complete: "Sale Complete",
    receipt: "Receipt",
    // Dashboard extras
    sales_word: "sales",
    last_7_days: "Last 7 days",
    last_30_days: "Last 30 days",
    avg_sale: "Avg Sale",
    month_revenue: "Month Revenue",
    per_transaction: "Per transaction",
    pending_orders: "Pending Orders",
    online_orders_waiting: "online orders awaiting action",
    online_orders_new_today: "new today",
    online_orders_view: "View Orders",
    recent_transactions: "Recent Transactions",
    // Vendors
    vendor_management: "Vendor Management",
    add_vendor: "Add Vendor",
    new_po: "New PO",
    purchase_orders: "Purchase Orders",
    receipts: "Receipts",
    bills: "Bills",
    vendors: "Vendors",
    categories: "Categories",
    receive: "Receive",
    pay: "Pay",
    submit: "Submit",
    // Reports
    reports: "Reports",
    reports_sub: "Track performance & inventory health",
    sales: "Sales",
    currency: "Currency",
    variants: "Variants",
    expenses: "Expenses",
    drawer: "Drawer",
    // Inventory extras
    products: "Products",
    gen_barcodes: "Gen Barcodes",
    multi_store: "Multi-Store",
    // Settings sections
    settings_sub: "Store configuration & management",
    store_information: "Store Information",
    currency_pricing: "Currency & Pricing",
    receipt_configuration: "Receipt Configuration",
    checkout_rules: "Checkout Rules",
    role_permissions: "Role Permissions",
    alerts_notifications: "Alerts & Notifications",
    security: "Security",
    pdf: "PDF",
    print: "Print",
    thank_you: "Thank you for your purchase!",
    rate: "Rate",
    // Audit/Coupons/Loyalty/Orders/Analytics
    export: "Export",
    item_col: "Item",
    audit_auto_note: "Actions like sales, edits, and logins are logged here automatically",
    new_coupon: "New Coupon",
    create_coupon: "Create Coupon",
    coupon_name_ph: "Coupon name (e.g. Birthday 10% Off)",
    type: "Type",
    value: "Value",
    min_purchase: "Min Purchase ($)",
    expiry_days: "Expiry (days)",
    birthday_coupon: "Birthday coupon",
    no_coupons: "No coupons yet.",
    send_to_customer: "Send to Customer",
    select_customer: "Select customer...",
    expires: "Expires",
    used: "Used",
    birthday: "Birthday",
    activate: "Activate",
    bonus_points: "Bonus Points",
    activity: "Activity",
    points_earned_30d: "Points Earned (30d)",
    transactions_30d: "Transactions (30d)",
    loyalty_members: "Loyalty Members",
    pts_per_usd: "Pts / $1 Spent",
    points_distribution: "Points Distribution",
    top_customers_spend: "Top Customers by Spend",
    no_customer_data: "No customer data yet",
    recent_loyalty_tx: "Recent Loyalty Transactions",
    no_loyalty_activity: "No loyalty activity yet",
    adjust: "Adjust",
    adjust_points: "Adjust Points",
    general: "General",
    enable_loyalty: "Enable Loyalty Program",
    earning_rules: "Earning Rules",
    redemption_rules: "Redemption Rules",
    expiration: "Expiration",
    reason: "Reason",
    orders_word: "orders",
    sales_orders: "Sales & Orders",
    export_csv: "Export CSV",
    refresh: "Refresh",
    revenue: "Revenue",
    on_account: "On Account",
    orders_search_ph: "Search by invoice #, customer, cashier...",
    today: "Today",
    this_month: "This Month",
    all_time: "All Time",
    completed: "Completed",
    returns: "Returns",
    returned: "Returned",
    no_sales_found: "No sales found",
    sales_appear_here: "Sales from POS will appear here",
    try_different_search: "Try a different search",
    customer: "Customer",
    cashier: "Cashier",
    payment: "Payment",
    tax: "Tax",
    points_redeemed: "Points Redeemed",
    change_due: "Change",
    receipt_pdf: "Receipt PDF",
    return_btn: "Return",
    confirm_return: "Confirm Return",
    return_reason_ph: "Reason for return...",
    advanced_analytics: "Advanced Analytics",
    analytics_sub: "Deep insights into your business performance",
    last_90_days: "Last 90 days",
    last_year: "Last year",
    customer_value: "Customer Value",
    profit_margins: "Profit Margins",
    staff_performance: "Staff Performance",
    sales_trends: "Sales Trends",
    cost: "Cost",
    profit: "Profit",
    margin: "Margin",
    // Customers/Staff/Stores/Shop
    customers: "Customers",
    customers_sub: "Manage customer accounts & balances",
    balance: "Balance",
    add_new: "Add New",
    staff_sub: "Manage team, shifts & payroll",
    clock_in: "Clock In",
    clock_out: "Clock Out",
    shifts: "Shifts",
    payroll: "Payroll",
    stores_sub: "Manage branches and sync inventory",
    add_store: "Add Store",
    online_shop: "Online Shop",
    view_store: "View Store",
    orders_tab: "Orders",
    language: "Language",
    total_customers: "Total Customers",
    outstanding_balance: "Outstanding Balance",
    total_points: "Total Points",
    customers_search_ph: "Search name, phone, email...",
    top_spenders: "Top Spenders",
    most_points: "Most Points",
    highest_balance: "Highest Balance",
    recent: "Recent",
    account: "Account",
    loyalty: "Loyalty",
    coupons_tab: "Coupons",
    notes: "Notes",
    no_customers: "No customers yet",
    staff_hr_title: "Staff & HR Management",
    add_staff: "Add Staff",
    active_staff_lbl: "Active Staff",
    today_present: "Today Present",
    pending_leave: "Pending Leave",
    shifts_month: "Shifts (Month)",
    payroll_total: "Payroll Total",
    leave: "Leave",
    clock_lbl: "Clock",
    store_management: "Store Management",
    overview: "Overview",
    details: "Details",
    staff_lbl: "Staff",
    login_welcome: "Welcome back",
    login_sub: "Select your account and enter PIN",
    login_store_sub: "Enter your Store ID to continue",
    login_store_title: "Which store are you signing in to?",
    login_store_hint: "Use the Store ID shown at signup, or the business phone number you registered with.",
    login_store_placeholder: "Store ID or business phone",
    login_store_continue: "Continue",
    login_store_not_found: "Store not found. Check your Store ID or phone number.",
    login_switch_store: "Switch store",
    select_account: "Select your account",
    loading_users: "Loading users...",
    no_users: "No users available",
    no_users_created: "No user accounts have been created for this store.",
    net_conn_problem: "Connection problem. Reconnecting…",
    retry: "Retry",
    users_load_failed: "Couldn't load accounts — tap to retry",
    net_reconnecting: "Connection lost — reconnecting…",
    net_details: "Details",
    net_details_hint: "Recent connection events on this device (your internet ↔ server):",
    net_back_online: "Back online",
    net_offline_hint: "Sales keep working — they sync automatically",
    off_cached_catalog: "Offline mode — using saved catalog",
    prn_warn_paper_out: "Receipt printer is OUT OF PAPER",
    prn_warn_offline: "Receipt printer is OFFLINE",
    prn_warn_paper_jam: "Receipt printer has a PAPER JAM",
    prn_warn_door_open: "Receipt printer cover is OPEN",
    prn_warn_no_toner: "Receipt printer is out of ink/toner",
    prn_warn_error: "Receipt printer reports an error",
    prn_warn_hint: "You can still complete the sale; fix the printer, then reprint the receipt.",
    enter_pin_for: "Enter PIN for",
    start_trial: "Start your 14-day free trial",
    // Common deep-pass
    lang_en: "English",
    lang_ar: "Arabic",
    on_lbl: "ON",
    off_lbl: "OFF",
    ok_lbl: "OK",
    amount_received: "Amount Received",
    total_due: "Total Due",
    total_paid_usd: "Total Paid (USD equiv.)",
    remaining_lbl: "Remaining",
    change_lbl: "Change",
    redeem_loyalty: "Redeem Loyalty Points",
    available_lbl: "available",
    max_lbl: "Max",
    store_credit_lbl: "Store Credit",
    sc_due_after: "Due after credit",
    off_badge: "Offline mode",
    off_pending: "pending sync",
    off_synced: "offline sale(s) synced",
    off_sync_dropped: "offline sale(s) could not sync (data issue)",
    off_cash_only: "Offline — cash payments only",
    off_no_loyalty: "Offline — store credit & points unavailable",
    off_sale_saved: "Sale saved offline — it will sync automatically",
    off_note: "Offline — cash only, sale will sync automatically",
    off_saved_badge: "Saved offline — will sync when connection returns",
    sync_now: "Sync now",
    wa_receipt_sent: "Receipt sent via WhatsApp",
    wa_send_receipt: "Send Receipt",
    discount_lbl: "Discount",
    processing: "Processing...",
    complete_sale: "Complete Sale",
    print_receipt: "Print Receipt",
    download_pdf: "Download PDF",
    usb_print: "USB Print",
    new_sale_btn: "New Sale",
    points_earned_sfx: "loyalty points earned",
    points_redeemed_sfx: "points redeemed",
    override_by: "Override approved by",
    receipt_preview_lbl: "Receipt Preview",
    wa_t_tpls_loaded: "new templates loaded (Arabic & English)",
    cfm_delete_product: "Delete Product",
    cfm_delete_category: "Delete Category",
    cfm_sure_delete: "Are you sure you want to delete",
    cfm_deactivate_vendor: "Deactivate Vendor",
    cfm_deactivate: "Deactivate",
    cfm_delete: "Delete",
    cfm_delete_po: "Delete Purchase Order",
    cfm_cancel_po: "Cancel Purchase Order",
    cfm_no_undo: "This action cannot be undone.",
    cfm_delete_store: "Delete Store",
    cfm_delete_store_q: "Delete store",
    cfm_delete_shift: "Delete Shift",
    cfm_delete_shift_desc: "Delete this shift record?",
    cfm_remove_option: "Remove Option",
    cfm_remove: "Remove",
    cfm_generate_variants: "Generate Variants",
    cfm_generate_pre: "Generate",
    cfm_generate_post: "variant combinations? This will replace existing variants.",
    cfm_delete_variant: "Delete Variant",
    cfm_delete_variant_desc: "Delete this variant?",
    wa_test_send: "Send Test",
    wa_test_title: "Send Test to Your Phone",
    wa_test_desc: "Sends this template to your own WhatsApp with sample data, exactly as customers receive it.",
    wa_test_phone_ph: "Your phone number (e.g. +961 70 123 456)",
    wa_t_test_sent: "Test message sent to",
    wa_t_phone_req: "Enter your phone number",
    t_sale_lbl: "Sale",
    t_completed_lbl: "completed!",
    t_sale_failed: "Sale failed",
    t_printer_connected: "Thermal printer connected",
    t_printer_connect_failed: "Failed to connect printer",
    t_printer_disconnected: "Printer disconnected",
    t_printer_not_connected: "Printer not connected",
    t_receipt_printed: "Receipt printed",
    t_print_failed: "Print failed",
    t_pdf_failed: "Failed to download PDF",
    copied_clipboard: "Copied to clipboard",
    day_mon: "Monday", day_tue: "Tuesday", day_wed: "Wednesday", day_thu: "Thursday", day_fri: "Friday", day_sat: "Saturday", day_sun: "Sunday",
    // WhatsApp page
    wa_tab_templates: "Templates",
    wa_tab_send: "Send Message",
    wa_tab_bulk: "Bulk Send",
    wa_tab_groups: "Groups",
    wa_tab_contacts: "Contacts",
    wa_tab_inbox: "Inbox",
    wa_tab_autoreply: "Auto-Reply",
    wa_tab_optouts: "Opt-Outs",
    wa_tab_history: "History",
    wa_tab_campaigns: "Campaigns",
    wa_tab_settings: "Settings",
    wa_banner_cloud: "Direct send via WhatsApp Cloud API",
    wa_banner_link: "Link mode — messages open in WhatsApp. Connect the Cloud API in Settings to send directly.",
    wa_new_template: "New Template",
    wa_load_defaults: "Load Default Templates",
    wa_tpl_name_ph: "Template name",
    wa_tpl_body_ph: "Message body. Use {name}, {points}, {balance}, {store_name} for personalization",
    wa_placeholders: "Placeholders:",
    wa_no_templates: 'No templates yet. Click "Load Default Templates" to get started with Arabic & English templates.',
    wa_cat_general: "General",
    wa_cat_birthday: "Birthday",
    wa_cat_promotion: "Promotion",
    wa_cat_loyalty: "Loyalty",
    wa_send_to_customer: "Send to Customer",
    wa_select_customer: "Select customer...",
    wa_use_template: "Use template (optional)...",
    wa_custom_msg_ph: "Or type a custom message...",
    wa_send_via: "Send via WhatsApp",
    wa_open_wa: "Open WhatsApp",
    wa_bulk_title: "Bulk Send to Customers",
    wa_select_template: "Select template...",
    wa_filter_all: "All Customers",
    wa_filter_loyalty: "Loyalty Members (with points)",
    wa_filter_high: "High Spenders ($100+)",
    wa_filter_bday: "Birthdays Today",
    wa_schedule_label: "Schedule for later (optional)",
    wa_schedule_clear: "Clear schedule (send now)",
    wa_optout_note: "Opted-out customers are always excluded.",
    wa_optout_note_stop: ' A "Reply STOP to unsubscribe" note is added to every broadcast.',
    wa_schedule_broadcast: "Schedule Broadcast",
    wa_start_broadcast: "Start Broadcast",
    wa_send_all: "Send to All",
    wa_conversations: "Conversations",
    wa_no_replies: "No replies yet. Customer WhatsApp replies appear here once webhooks are configured (Settings tab).",
    wa_select_conv: "Select a conversation",
    wa_no_msgs: "No messages in this conversation.",
    wa_reply_ph: "Type a reply...",
    wa_reply_hint: "Connect the WhatsApp Cloud API in Settings to reply from here.",
    wa_ar_title: "Auto-Reply Rules",
    wa_ar_desc: "When a customer message contains one of the keywords, the reply is sent automatically via the Cloud API. Requires the Cloud API connection and webhook (Settings tab). STOP/START always take priority.",
    wa_ar_keywords_ph: "Keywords, comma separated (e.g. hours, open, دوام)",
    wa_ar_reply_ph: "Automatic reply message...",
    wa_ar_add: "Add Rule",
    wa_ar_seed: "Add Example Rules",
    wa_ar_none: "No auto-reply rules yet. Add one above or load the examples.",
    wa_matched: "Matched",
    wa_times: "time(s)",
    wa_optouts_title: "Broadcast Opt-Outs",
    wa_optouts_desc: "Opted-out customers are excluded from all bulk broadcasts. When a customer replies STOP on WhatsApp, mark them as opted out here.",
    wa_opted_out_count: "customer(s) opted out.",
    wa_no_customers: "No customers with phone numbers yet.",
    wa_opted_out: "Opted Out",
    wa_subscribed: "Subscribed",
    wa_no_messages: "No messages sent yet.",
    wa_read: "Read",
    wa_delivered: "Delivered",
    wa_weekly_title: "Weekly Auto Offers",
    wa_weekly_desc: "Send a template automatically every week — no re-scheduling. Requires the Cloud API connection.",
    wa_rec_filter_loyalty: "Loyalty Members",
    wa_rec_filter_high: "High Spenders",
    wa_create_weekly: "Create Weekly Offer",
    wa_every: "Every",
    wa_last_sent: "Last sent",
    wa_no_campaigns: "No campaigns yet.",
    wa_scheduled_for: "Scheduled for",
    wa_recipients: "recipients",
    wa_sent_lbl: "sent",
    wa_failed_lbl: "failed",
    wa_filter_lbl: "Filter:",
    wa_connected_title: "WhatsApp Cloud API Connected",
    wa_phone_id_lbl: "Phone Number ID:",
    wa_quality_lbl: "Quality:",
    wa_disconnect: "Disconnect",
    wa_connect_title: "Connect Meta WhatsApp Cloud API",
    wa_connect_desc: "Send messages directly from the software — no wa.me tabs. Get your credentials from developers.facebook.com → Your App → WhatsApp → API Setup: copy the Phone Number ID (not the phone number itself) and a permanent Access Token (System User token recommended).",
    wa_update_creds: "Update Credentials",
    wa_creds: "Credentials",
    wa_phone_id_ph: "Phone Number ID (e.g. 106540352242922)",
    wa_token_ph: "Access Token",
    wa_verifying: "Verifying...",
    wa_connect_verify: "Connect & Verify",
    wa_creds_note: "Credentials are verified against Meta before saving and stored encrypted.",
    wa_test_conn: "Test Connection",
    wa_testing: "Testing...",
    wa_test_ok: "WhatsApp connection OK",
    wa_test_fail: "Connection test failed",
    wa_verified_name: "Verified name",
    wa_display_phone: "Phone number",
    wa_acct_status: "Account status",
    wa_quality: "Quality rating",
    wa_msg_limit: "Messaging limit",
    wa_platform: "Platform",
    wa_name_status: "Name status",
    wa_code_verif: "Code verification",
    wa_register_title: "Register number on Cloud API",
    wa_register_desc: "If sends fail with Meta error #133010 (Account not registered), register your number here using your 6-digit two-step verification PIN.",
    wa_fb_title: "24-Hour Window Fallback",
    wa_fb_desc: "WhatsApp blocks free-text messages sent more than 24 hours after the customer's last reply (Meta error #131047). Pick an approved Meta template below — when a send hits that limit, the app automatically sends the template instead so your message still arrives.",
    wa_fb_current: "Active fallback:",
    wa_fb_not_set: "No fallback template set — sends to customers who haven't replied in the last 24 hours will FAIL.",
    wa_fb_load: "Load approved templates",
    wa_fb_waba_ph: "WABA ID (only if auto-detect fails)",
    wa_fb_none_opt: "No fallback (disabled)",
    wa_fb_save: "Save fallback",
    wa_fb_saved: "Fallback template saved",
    wa_fb_save_failed: "Could not save fallback",
    wa_fb_load_failed: "Could not load templates from Meta",
    wa_fb_none_found: "No approved templates found in your WhatsApp account. Create one in Meta WhatsApp Manager first.",
    wa_fb_too_many_vars: "(too many variables)",
    wa_fb_vars_hint: "{{1}} = customer name · {{2}} = store name",
    wa_tpl_badge: "TEMPLATE",
    wa_mt_title: "Official Meta Templates",
    wa_mt_desc: "These are your real WhatsApp templates reviewed by Meta. Approved templates can be sent any time — even outside the 24-hour window. Draft one below and submit it for approval without leaving the app.",
    wa_mt_name_ph: "template_name (lowercase, underscores)",
    wa_mt_body_ph: "Template text… use {{1}} for the customer name and {{2}} for your store name",
    wa_mt_submit: "Submit for approval",
    wa_mt_submitted: "Template submitted to Meta",
    wa_mt_failed: "Meta template action failed",
    wa_mt_deleted: "Template deleted",
    wa_mt_none: "No Meta templates yet — create your first one above.",
    wa_mt_req: "Enter a template name and body",
    wa_mt_cat_marketing: "Marketing (promos, offers)",
    wa_mt_cat_utility: "Utility (order updates)",
    wa_mt_vars_hint: "Approval usually takes minutes to a few hours. {{1}} = customer name, {{2}} = store name.",
    wa_mt_presets: "Ready-made starters — tap to fill, then submit:",
    wa_retry_failed: "Retry failed",
    wa_retry_ok: "Failed messages requeued",
    wa_retry_failed_err: "Could not retry",
    wa_window_open: "Free-text window open",
    wa_window_closed: "Window closed — approved template will be used",
    wa_media_sent: "Media sent",
    wa_media_failed: "Could not send media",
    wa_document: "Document",
    wa_qr_title: "Quick replies",
    wa_qr_none: "No quick replies yet — save your first one below (opening hours, delivery fees…).",
    wa_qr_title_ph: "Title",
    wa_qr_text_ph: "Reply text… ({name} = customer)",
    wa_qr_add: "Save",
    wa_qr_saved: "Quick reply saved",
    wa_qr_req: "Enter a title and text",
    wa_qr_failed: "Quick reply action failed",
    wa_start_order: "Start order",
    wa_order_cust_created: "Customer created from this chat",
    wa_order_cust_linked: "Linked to existing customer",
    wa_order_failed: "Could not start the order",
    wa_greet_title: "First-Contact Welcome",
    wa_greet_desc: "Automatically greet a number the very first time it messages your store. Supports {name} and {store_name}. When the greeting is sent, keyword auto-replies are skipped for that first message.",
    wa_greet_ph: "Hi {name}! Welcome to {store_name} — how can we help you today?",
    wa_greet_save: "Save welcome message",
    wa_greet_saved: "Welcome message saved",
    wa_away_title: "Away-Hours Auto Answer",
    wa_away_desc: "Outside your opening hours, customers who message you get an automatic \"we'll get back to you\" note (max once per chat every 6 hours). Welcome and keyword replies take priority.",
    wa_away_open: "Open from",
    wa_away_ph: "Thanks for your message! We're currently closed — we'll get back to you as soon as we open. 🕐",
    wa_away_saved: "Away reply saved",
    wa_away_save: "Save away reply",
    wa_notes_title: "Internal Notes",
    wa_notes_desc: "Private notes for your team only — the customer never sees these.",
    wa_notes_ph: "Add a private note…",
    wa_rcpt_send: "Send receipt PDF to this chat",
    wa_rcpt_sent: "Receipt sent to chat",
    wa_rcpt_failed: "Could not send the receipt",
    wa_tk_autorenew: "Token auto-renew",
    wa_tk_on: "ON",
    wa_tk_off: "OFF",
    wa_tk_permanent: "PERMANENT — never expires",
    wa_tk_renew_now: "Renew now",
    wa_tk_expires: "Token expires",
    wa_tk_renewed: "Last auto-renewed",
    wa_tk_renewed_ok: "Token renewed — fresh 60 days",
    wa_tk_still_valid: "Token is valid — no renewal needed yet",
    wa_tk_reauth: "Token is expired/revoked — paste a new token in Settings (expired tokens can't be renewed)",
    wa_tk_renew_failed: "Renewal failed",
    wa_tk_setup_hint: "To renew automatically, add your Meta App ID & App Secret in Settings → Social — or generate a permanent System User token in Meta Business Manager (never expires).",
    wa_cust_panel: "Customer",
    wa_cust_none: "No customer record matches this number yet — tap Start order to create one.",
    wa_cust_spent: "Total spent",
    wa_cust_points: "Points",
    wa_cust_credit: "Store credit:",
    wa_cust_recent: "Recent orders",
    wa_cust_no_orders: "No orders yet",
    wa_cust_online: "Online",
    wa_grp_title: "Broadcast Groups",
    wa_grp_desc: "Build audience lists of any phone numbers — even people who never messaged you — and send them promotions. WhatsApp only delivers to cold numbers via an APPROVED Meta template (that's the #131047 'Re-engagement' error you saw), so group sends use your approved templates. Recipients can reply STOP anytime to opt out automatically.",
    wa_grp_name_ph: "New group name…",
    wa_grp_name_req: "Enter a group name",
    wa_grp_created: "Group created",
    wa_grp_deleted: "Group deleted",
    wa_grp_none: "No groups yet — create your first audience above.",
    wa_grp_select: "Select or create a group to manage members and send promotions",
    wa_grp_members: "members",
    wa_grp_opted_out: "opted out",
    wa_grp_entries_ph: "Paste phone numbers — one per line:\n+96170123456\n+96171234567, Sara\n70345678",
    wa_grp_entries_req: "Paste at least one phone number",
    wa_grp_add_btn: "Add numbers",
    wa_grp_import_cust: "Add all customers",
    wa_grp_import_file: "Import CSV/Excel",
    wa_grp_file_failed: "Could not import this file",
    wa_grp_added: "Added",
    wa_grp_invalid: "invalid",
    wa_grp_dup: "duplicates",
    wa_grp_in: "IN",
    wa_grp_out: "OUT",
    wa_grp_send_title: "Send promotion to this group",
    wa_grp_mode_tpl: "Approved template (reaches everyone)",
    wa_grp_mode_text: "Free text (24h window only)",
    wa_grp_tpl_hint: "Approved Meta templates are delivered to ALL members — including numbers that never messaged you. {{1}} fills with the member's name, {{2}} with your store name.",
    wa_grp_text_hint: "Free text is only delivered to members who messaged you in the last 24 hours — everyone else fails with Meta #131047. Use an approved template to reach the whole group.",
    wa_grp_no_tpl: "No approved templates yet — create one in the Templates tab and wait for Meta approval.",
    wa_grp_pick_tpl: "Choose an approved template…",
    wa_grp_msg_ph: "Your promotion… ({name} = member name, {store_name} = store)",
    wa_grp_msg_req: "Write a message",
    wa_grp_sent: "Broadcast started",
    wa_grp_send_btn: "Send to group",
    wa_grp_stop_note: "Members who reply STOP are opted out automatically and skipped in future sends. Track progress in the Campaigns tab.",
    wa_grp_reality: "Note: these are broadcast lists in your POS — Meta's Cloud API cannot create or manage real WhatsApp group chats. You can store a group invite link below for reference.",
    wa_grp_invite_ph: "Optional: paste a WhatsApp group invite link (managed on your phone)",
    wa_grp_invite_saved: "Invite link saved",
    wa_grp_invite_open: "Open",
    wa_search_conv: "Search chats…",
    wa_new_chat: "New chat",
    wa_filter_unread: "Unread",
    wa_filter_archived: "Archived",
    wa_pin: "Pin conversation",
    wa_archive: "Archive conversation",
    wa_reply_to: "Reply to this message",
    wa_mic_start: "Record voice note",
    wa_mic_stop: "Stop & send",
    wa_mic_denied: "Microphone access was denied — allow it in your browser settings, or attach an audio file instead",
    wa_nc_name_ph: "Name (optional)",
    wa_nc_save_lbl: "Save as new customer in my directory",
    wa_nc_existing: "Matching existing customers — tap to open their chat:",
    wa_nc_open: "Open conversation",
    wa_nc_note: "Opening a conversation never sends anything. First messages to numbers that haven't written you require an approved template (Meta rule).",
    wa_nc_failed: "Could not open the conversation",
    wa_nc_phone_req: "Enter a phone number",
    wa_ct_title: "Contacts Directory",
    wa_ct_desc: "All customers with a phone number, straight from your Customers module (same records — edits stay in sync). Stored in your POS database, not your phone's address book.",
    wa_ct_search_ph: "Search by name or number…",
    wa_ct_chat: "Chat",
    wa_ct_none: "No customers with phone numbers yet — add one from the Customers page or via New chat.",
    wa_ct_name_ph: "Customer name…",
    wa_ct_name_req: "Enter a name first",
    wa_cust_save: "Save as customer",
    wa_cust_link: "Link number to selected customer",
    wa_cust_link_pick: "Link to existing customer…",
    wa_cust_linked_ok: "Number linked to customer",
    wa_dg_title: "Connection Diagnostics",
    wa_dg_run: "Run diagnostics",
    wa_dg_hint: "Checks your credential status, permissions and webhook activity — without exposing the token.",
    wa_dg_number: "Number",
    wa_dg_token: "Access token",
    wa_dg_valid: "VALID",
    wa_dg_invalid: "INVALID / EXPIRED",
    wa_dg_token_fix: "Generate a new permanent token in Meta Business Settings (System User) and re-save it under Credentials below — your existing configuration is never deleted automatically.",
    wa_dg_perms: "Permissions",
    wa_dg_webhook: "Last webhook event",
    wa_dg_webhook_never: "No webhook event received yet — a successful API check does NOT prove incoming messages work; ask someone to message your number to verify.",
    wa_dg_not_resolved: "not resolved yet",
    wa_dg_note: "Sending and receiving are verified separately: token = sending capability, webhook = receiving.",
    wa_dg_coex: "Phone app coexistence: your WhatsApp Business app keeps working alongside the API if the number was onboarded with coexistence — Meta offers no API to verify this remotely.",
    wa_dg_groups: "WhatsApp group chats: not supported by Meta's Cloud API — the Groups tab provides broadcast lists instead.",
    wa_dg_failed: "Diagnostics failed",
    wa_register_pin_ph: "6-digit two-step verification PIN",
    wa_register_btn: "Register Number",
    wa_registering: "Registering...",
    wa_registered_ok: "Number registered on Cloud API successfully",
    wa_register_failed: "Registration failed",
    wa_register_pin_invalid: "Enter the 6-digit PIN",
    wa_webhook_title: "Webhooks — Delivery Receipts & Auto Opt-Out",
    wa_webhook_desc: "Configure this webhook in your Meta app (WhatsApp → Configuration → Webhooks) and subscribe to the messages field. You'll then see delivered/read receipts in History, customer replies in the Inbox tab, and customers who reply STOP are opted out automatically (START re-subscribes).",
    wa_callback_url: "Callback URL",
    wa_verify_token: "Verify Token",
    wa_t_keywords_req: "Keywords and reply are required",
    wa_t_rule_added: "Auto-reply rule added",
    wa_t_add_failed: "Failed to add rule",
    wa_t_update_failed: "Failed to update",
    wa_t_delete_failed: "Failed to delete",
    wa_t_rule_deleted: "Rule deleted",
    wa_t_examples_failed: "Failed to add examples",
    wa_t_select_template: "Select a template",
    wa_t_weekly_created: "Weekly auto offer created",
    wa_t_create_failed: "Failed to create",
    wa_t_weekly_deleted: "Weekly offer deleted",
    wa_t_name_body_req: "Name and message body required",
    wa_t_tpl_updated: "Template updated",
    wa_t_tpl_created: "Template created",
    wa_t_tpl_save_failed: "Failed to save template",
    wa_t_tpl_deleted: "Template deleted",
    wa_t_select_customer: "Select a customer",
    wa_t_select_tpl_or_msg: "Select a template or write a message",
    wa_t_sent_to: "Message sent to",
    wa_t_wa_opened: "WhatsApp opened",
    wa_t_send_failed: "Failed to send",
    wa_t_broadcast_scheduled: "Broadcast scheduled for",
    wa_t_customers_word: "customers",
    wa_t_broadcast_started: "Broadcast started — sending to",
    wa_t_msgs_prepared: "messages prepared",
    wa_t_failed: "Failed",
    wa_t_cancel_failed: "Failed to cancel",
    wa_t_broadcast_cancelled: "Scheduled broadcast cancelled",
    wa_t_creds_req: "Phone Number ID and Access Token are required",
    wa_t_connected: "Connected:",
    wa_t_verify_failed: "Verification failed",
    wa_t_disconnected: "WhatsApp Cloud API disconnected",
    wa_t_disconnect_failed: "Failed to disconnect",
    wa_t_opted_out_sfx: "opted out of broadcasts",
    wa_t_resub_sfx: "re-subscribed",
    wa_t_conv_failed: "Could not load conversation",
    wa_t_reply_failed: "Failed to send reply",
    // Social page
    soc_title: "Social Media",
    soc_subtitle: "Connect your social accounts to manage your online presence",
    soc_secure_title: "Secure Connection",
    soc_secure_desc: "You'll sign in directly on each platform's official website. We never see or store your social media password. Only the access granted by you is saved, fully encrypted.",
    soc_connected: "Connected",
    soc_disconnected: "Disconnected",
    soc_needs_reconnect: "Needs Reconnect",
    soc_token_expired: "Token expired",
    soc_not_connected: "Not connected",
    soc_connected_by: "Connected by",
    soc_expired_warning: "Your access token has expired. Please reconnect to continue managing this account.",
    soc_reconnect: "Reconnect",
    soc_disconnect: "Disconnect",
    soc_connecting: "Connecting...",
    soc_connect: "Connect",
    soc_create_post: "Create Post",
    soc_product_to_post: "Product to Post",
    soc_post_ph: "Write your offer or announcement...",
    soc_img_ph: "Image URL (optional — required for Instagram)",
    soc_publish: "Publish",
    soc_recent_posts: "Recent Posts",
    soc_no_posts: "No posts yet. Publish your first offer above!",
    soc_comments: "comment(s)",
    soc_view: "View",
    soc_no_comments: "No comments yet.",
    soc_no_text: "(no text)",
    soc_conn_status: "Connection Status",
    soc_pick_product_desc: "Pick a product — we'll draft the offer with its photo and price.",
    soc_search_products: "Search products...",
    soc_no_products: "No products found.",
    soc_setup_needed: "Setup Needed",
    soc_not_configured: "Social media connections aren't set up for this store yet.",
    soc_contact_admin: "Please contact your store administrator to enable Facebook and Instagram connections. Once configured, you'll be able to connect your accounts with a single click.",
    soc_t_connected: "connected",
    soc_t_conn_failed: "Connection failed. Please try again.",
    soc_t_start_failed: "Could not start connection. Please try again.",
    soc_disconnect_desc: "You can reconnect at any time. This won't affect your existing posts.",
    soc_t_disconnected: "disconnected",
    soc_t_disc_failed: "Failed to disconnect",
    soc_t_select_platform: "Select at least one connected platform",
    soc_t_write_msg: "Write a message or add an image",
    soc_t_ig_img: "Instagram posts require an image URL",
    soc_t_posted: "Posted to",
    soc_t_publish_failed: "Failed to publish post",
    soc_t_comments_failed: "Could not load comments",
    soc_t_products_failed: "Could not load products",
    soc_t_offer_drafted: "Offer drafted for",
    // Branding page
    brand_title: "Store Branding",
    brand_subtitle: "Customize your store's colors, logo, and identity",
    brand_save: "Save Changes",
    brand_logo: "Store Logo",
    brand_remove: "Remove",
    brand_drag: "Drag & drop your logo or",
    brand_browse: "browse",
    brand_logo_hint: "PNG, JPG up to 2MB. 200x200px recommended.",
    ai_digest_title: "AI Daily Digest",
    ai_digest_hint: "Get a ten-second AI summary of today's performance.",
    ai_digest_btn: "Generate digest",
    ai_digest_busy: "Thinking...",
    ai_insights_title: "AI Insights Assistant",
    ai_insights_empty: "Ask me anything about your sales, profit, stock or orders.",
    ai_insights_ph: "e.g. What sold best this week?",
    ai_new_chat: "New chat",
    ai_error: "AI is unavailable right now. Please try again.",
    ai_caption_btn: "Rewrite caption with AI",
    ai_caption_saved: "AI caption saved for this product",
    brand_hero: "Shop Hero Photo",
    brand_hero_hint: "Shown at the top of your online shop. PNG or JPG up to 5MB — wide photos (1600px+) look best.",
    brand_hero_uploaded: "Hero photo uploaded",
    brand_hero_remove: "Remove — use default photo",
    brand_theme: "Theme",
    brand_primary: "Primary",
    brand_accent: "Accent",
    brand_live_preview: "Live Preview",
    brand_primary_btn: "Primary Button",
    brand_outline: "Outline",
    brand_badge: "Badge",
    brand_active_nav: "Active Nav",
    brand_tagline: "Tagline",
    brand_tagline_ph: "Your one-stop shop for amazing gifts",
    brand_company: "Company Info",
    brand_company_desc: "Shown on receipts, invoices, and PDFs",
    brand_address: "Address",
    brand_phone: "Phone",
    brand_email: "Email",
    brand_tax: "Tax / VAT Number",
    brand_receipt_footer: "Receipt Footer",
    brand_receipt_opts: "Receipt Display Options",
    brand_show_logo: "Show Logo",
    brand_show_address: "Show Address",
    brand_show_phone: "Show Phone",
    brand_show_tax: "Show Tax Number",
    brand_sidebar_preview: "Sidebar Preview",
    brand_receipt_preview: "Receipt Preview",
    brand_t_saved: "Branding & company info saved!",
    brand_t_save_failed: "Failed to save",
    brand_t_logo_uploaded: "Logo uploaded!",
    brand_t_logo_failed: "Failed to upload logo",
    // WhatsApp Orders page
    wao_title: "WhatsApp Orders",
    wao_total: "total",
    wao_today: "today",
    wao_pending: "Pending",
    wao_confirmed: "Confirmed",
    wao_ready: "Ready",
    wao_completed: "Completed",
    wao_cancelled: "Cancelled",
    wao_revenue: "Revenue",
    wao_search_ph: "Search by name, phone, order#...",
    wao_all_orders: "All Orders",
    wao_no_orders: "No WhatsApp orders",
    wao_with_status: "with status",
    wao_hint: "Orders placed via the online shop will appear here",
    wao_delivery: "Delivery",
    wao_items_word: "items",
    wao_confirm: "Confirm",
    wao_mark_ready: "Mark Ready",
    wao_complete: "Complete",
    wao_no_phone: "No phone",
    wao_order_items: "Order Items",
    wao_customer_note: "Customer note:",
    wao_chat: "Chat on WhatsApp",
    wao_copy_tracking: "Copy Tracking Link",
    wao_ready_photo: "Packed Order Photo",
    wao_upload_photo: "Add a photo of the packed order",
    wao_replace_photo: "Replace",
    wao_remove_photo: "Remove",
    wao_photo_hint: "Sent to the customer with the \"ready\" WhatsApp message.",
    wao_photo_added: "Photo added",
    wao_photo_removed: "Photo removed",
    wao_photo_invalid: "Please choose an image file",
    wao_photo_too_big: "Image must be under 8MB",
    ap_title: "Auto-Post Products",
    ap_desc: "Automatically publish your inventory to Facebook & Instagram with photo, price (USD + LBP) and shop link.",
    ap_auto_new: "Auto-post new products",
    ap_auto_new_hint: "Every product added to inventory is queued and posted automatically",
    ap_queue_all: "Post All Products",
    ap_queue_all_title: "Post all products?",
    ap_queue_all_desc: "All active products will be queued and posted gradually (one every 30 minutes) to Facebook & Instagram. Products already posted are skipped.",
    ap_post_next: "Post Next Now",
    ap_pause: "Pause",
    ap_resume: "Resume",
    ap_clear: "Clear Queue",
    ap_clear_title: "Clear the queue?",
    ap_clear_desc: "All pending (not yet posted) products will be removed from the queue.",
    ap_queued: "Queued",
    ap_posted: "Posted",
    ap_failed: "Failed",
    ap_retry: "Retry",
    ap_remove: "Remove",
    ap_paused_note: "Queue is paused — nothing will be posted until you resume.",
    ap_pace_note: "Posts 1 product every {n} minutes to stay within Meta limits (~50 Instagram posts/day). Products without a photo are posted text-only on Facebook and skipped on Instagram.",
    ap_connect_first: "Connect Facebook or Instagram above to start posting.",
    ap_t_saved: "Saved",
    ap_t_failed: "Action failed",
    ap_t_queued: "products queued",
    ap_t_skipped: "already queued/posted skipped",
    ap_t_posted: "Posted",
    ap_t_requeued: "Requeued",
    ap_t_cleared: "removed from queue",
    ap_hours_title: "Posting Hours",
    ap_hours_hint: "Only post while your audience is awake",
    ap_hours_any: "Any time",
    ap_hours_outside: "Outside window — waiting",
    ap_preview: "Preview post",
    ap_preview_title: "Post Preview",
    ap_preview_no_image: "No product photo — will post text-only on Facebook, skipped on Instagram",
    ap_preview_no_base: "Set your shop link in Settings → Online Shop so posts include photos and a store link.",
    wao_sale_created: "Recorded as sale",
    wao_each: "each",
    wao_coupon: "Coupon discount",
    wao_loyalty: "Loyalty discount",
    wao_delivery_fee: "Delivery fee",
    wao_tax: "Tax",
    wao_return_refund: "Return & Refund",
    wao_return_order: "Return this order?",
    wao_return_q: "All items will be restocked and the sale reversed:",
    wao_returned: "Returned",
    wao_refunded: "refunded",
    wao_notif_history: "Notification History",
    wao_via: "via",
    wao_admin_notes: "Admin Notes",
    wao_notes_ph: "Internal notes...",
    wao_just_now: "Just now",
    wao_cancel_order: "Cancel Order",
    wao_cancel_q: "Cancel order",
    wao_t_notes_saved: "Notes saved",
    wao_t_tracking_copied: "Tracking link copied!",
    wao_t_wa_opened: "WhatsApp opened — tap Send to notify the customer",
    // Social & Meta Commerce (sp_)
    sp_title: "Social & Meta Commerce",
    sp_subtitle: "Publish to Facebook & Instagram, sync your inventory to the Meta Catalog",
    sp_tab_facebook: "Facebook",
    sp_tab_all: "All Channels",
    sp_all_title: "Post to All Channels",
    sp_all_publish: "Publish Everywhere",
    sp_all_pick_channel: "Pick at least one channel",
    sp_all_ig_needs_photo: "Instagram needs a photo — add one or unselect Instagram",
    sp_all_partial: "channels published — check results below",
    sp_all_wa_confirm_title: "Send to WhatsApp customers?",
    sp_all_wa_confirm_desc: "This will message every opted-in customer on WhatsApp right now. Continue?",
    sp_view_post: "View",
    sp_tab_analytics: "Analytics",
    sp_analytics_title: "Channel Performance",
    sp_analytics_sub: "Likes, comments and reach per channel side by side",
    sp_analytics_demo_note: "Some numbers are demo values (simulation mode posts).",
    sp_top_performer: "Top performer",
    sp_posts: "Posts",
    sp_avg_engagement: "Avg engagement",
    sp_likes: "Likes",
    sp_comments: "Comments",
    sp_shares: "Shares",
    sp_best_hour: "Best hour",
    sp_from_posts: "from your posts",
    sp_suggested_default: "suggested",
    sp_top_post: "Top post",
    sp_no_posts_yet: "No published posts on this channel yet.",
    sp_apply_best_time: "Apply",
    sp_tab_instagram: "Instagram",
    sp_tab_stories: "Stories",
    sp_tab_catalog: "Meta Catalog",
    sp_tab_planner: "Planner",
    sp_tab_history: "History",
    sp_tab_settings: "Social Settings",
    sp_sim_mode: "Simulation mode",
    sp_connected: "Connected",
    sp_off: "Off",
    sp_select_products: "Select Products",
    sp_select_product: "Select Product",
    sp_fb_post: "Facebook Post",
    sp_ig_post: "Instagram Post",
    sp_story_24h: "Story (24h)",
    sp_headline_ph: "Post title / headline (optional)",
    sp_caption_ph: "Caption — write it yourself or generate with AI, then edit freely…",
    sp_ig_caption_ph: "Caption + hashtags — generate with AI, then edit freely…",
    sp_link_ph: "Shop / product URL (uses your public store domain)",
    sp_video_ph: "Optional video URL (public HTTPS — Meta downloads it)",
    sp_ig_video_ph: "Video / Reel URL (public HTTPS) — overrides selected images",
    sp_story_video_ph: "Video URL (public HTTPS, max 60s, 9:16 recommended) — overrides image",
    sp_images_label: "Images (pick one for a photo post, several for a multi-photo post)",
    sp_media_required_label: "Media",
    sp_required: "*required",
    sp_ig_media_hint: "— one image, 2-10 for a carousel, or a video/Reel URL",
    sp_story_media_hint: "— one image (9:16 works best) or a video URL",
    sp_upload: "Upload",
    sp_no_images_hint: "No product images yet — select a product or upload a marketing image.",
    sp_schedule_optional: "Schedule (optional)",
    sp_your_tz: "(your store timezone)",
    sp_clear: "clear",
    sp_publish_now: "Publish Now",
    sp_schedule_post: "Schedule Post",
    sp_publish_story: "Publish Story",
    sp_schedule: "Schedule",
    sp_preview: "Preview",
    sp_story_preview: "Story Preview",
    sp_916_preview: "9:16 preview",
    sp_stories_expire: "Stories disappear after 24 hours",
    sp_ig_no_media: "Instagram requires a photo or video. Please select media before publishing.",
    sp_story_no_media: "A Story needs a photo or video.",
    sp_fb_story: "Facebook Story",
    sp_ig_story: "Instagram Story",
    sp_ai_style: "Style",
    sp_ai_language: "Language",
    sp_ai_cta: "Call to action",
    sp_ai_model: "AI model",
    sp_generate_fb_ai: "Generate Facebook Post with AI",
    sp_generate_ig_ai: "Generate Instagram Post with AI",
    sp_style_professional: "Professional",
    sp_style_friendly: "Friendly",
    sp_style_sales: "Sales-focused",
    sp_style_new_arrival: "New Arrival",
    sp_style_premium: "Premium",
    sp_style_seasonal: "Seasonal",
    sp_style_promotional: "Promotional",
    sp_style_short: "Short",
    sp_style_detailed: "Detailed",
    sp_lang_en: "English",
    sp_lang_ar: "Arabic",
    sp_lang_both: "English + Arabic",
    sp_cta_shop: "Shop Online",
    sp_cta_whatsapp: "Order on WhatsApp",
    sp_cta_visit: "Visit Store",
    sp_cta_message: "Send Message",
    sp_cta_learn: "Learn More",
    sp_cta_none: "No CTA",
    sp_cat_title: "Meta Catalog",
    sp_cat_configured: "Configured",
    sp_cat_not_configured: "Not configured",
    sp_cat_no_id: "No Catalog ID configured — add it in Social Settings",
    sp_cat_id: "Catalog ID",
    sp_cat_synced: "Synced",
    sp_cat_failed: "Failed",
    sp_cat_autosync: "Auto Sync",
    sp_cat_lastsync: "Last Sync",
    sp_cat_sync_all: "Sync All Products",
    sp_cat_sync_selected: "Sync Selected Products",
    sp_cat_publish_new: "Publish New Products",
    sp_cat_update_existing: "Update Existing",
    sp_cat_retry_failed: "Retry Failed",
    sp_cat_history: "Catalog Sync History",
    sp_cat_no_activity: "No catalog activity yet",
    sp_cat_syncing: "Synchronizing…",
    sp_cat_products: "products",
    sp_all: "All",
    sp_retry: "Retry",
    sp_all_platforms: "All platforms",
    sp_all_statuses: "All statuses",
    sp_st_published: "Published",
    sp_st_failed: "Failed",
    sp_st_scheduled: "Scheduled",
    sp_st_pending: "Pending approval",
    sp_st_publishing: "Publishing…",
    sp_st_draft: "Draft",
    sp_st_drafts: "Drafts",
    sp_st_rejected: "Rejected",
    sp_st_cancelled: "Cancelled",
    sp_refresh_insights: "Refresh Insights",
    sp_top_products: "Top Performing Products",
    sp_demo_numbers: "demo numbers",
    sp_reach: "reach",
    sp_demo: "demo",
    sp_auto: "auto",
    sp_by: "by",
    sp_publishes: "publishes",
    sp_simulated: "simulated",
    sp_story_badge: "story",
    sp_approve: "Approve",
    sp_now: "Now",
    sp_publish: "Publish",
    sp_edit_post: "Edit post",
    sp_headline: "Headline",
    sp_reschedule_optional: "Reschedule (optional)",
    sp_save: "Save",
    sp_cancel: "Cancel",
    sp_recent_fb: "Recent Posts (live from Facebook)",
    sp_load: "Load",
    sp_no_posts: "No posts yet — publish from the Facebook or Instagram tab",
    sp_no_recent: "No recent Page posts",
    sp_fb_not_connected: "Facebook is not connected",
    sp_no_text: "(no text)",
    sp_planner_title: "Weekly Post Planner",
    sp_planner_desc: "AI proposes one post per day from your newest products. Nothing publishes until you approve.",
    sp_planner_platform: "Platform",
    sp_planner_days: "Days",
    sp_planner_time: "Post time",
    sp_planner_alternate: "Alternate FB/IG",
    sp_planner_fb_only: "Facebook only",
    sp_planner_ig_only: "Instagram only",
    sp_days_suffix: "days",
    sp_include_story: "Also queue one product story per day",
    sp_generate_week: "Generate Week of Posts with AI",
    sp_generating: "Generating…",
    sp_posts_word: "posts",
    sp_last_run: "Last run",
    sp_proposed_suffix: "proposed",
    sp_skipped_suffix: "skipped",
    sp_awaiting_approval: "Proposed posts awaiting approval",
    sp_approve_all: "Approve All Week",
    sp_no_proposed: "No proposed posts — generate a week above",
    sp_appearing: "Posts will appear here as the AI writes them…",
    sp_planner_tip: "Tip: edit any proposed post from the History tab before approving.",
    sp_best_time: "Best Time to Post",
    sp_use_hour: "Use this hour",
    sp_best_time_more_a: "Based on",
    sp_best_time_more_b: "posts so far — publish more (and refresh insights) for a stronger recommendation.",
    sp_conn_fb: "Facebook",
    sp_conn_ig: "Instagram",
    sp_conn_catalog: "Meta Catalog",
    sp_not_set: "Not set",
    sp_error: "Error",
    sp_test: "Test",
    sp_connect: "Connect",
    sp_verified: "Verified",
    sp_not_connected_short: "Not connected",
    sp_public_domain_title: "Public Store Domain",
    sp_public_domain_desc: "All product links in posts, captions and the Meta Catalog use this domain (e.g. https://www.yourstore.com).",
    sp_auto_detected: "Auto-detected:",
    sp_meta_creds: "Meta Credentials",
    sp_meta_creds_desc: "Connecting with the buttons above fills these automatically. You can also paste them manually — the token is encrypted and never shown again.",
    sp_page_id_ph: "Facebook Page ID",
    sp_ig_id_ph: "Instagram Account ID",
    sp_catalog_id_ph: "Meta Catalog ID",
    sp_token_ph: "Page Access Token",
    sp_token_saved_ph: "Page Access Token (saved ✓ — paste to replace)",
    sp_autopost_fb: "Auto-Post to Facebook",
    sp_autopost_ig: "Auto-Post to Instagram",
    sp_ig_autopost_note: "Instagram auto-posts run only when the product has a valid public image — text-only posts are never created.",
    sp_require_approval: "Require Approval Before Publishing",
    sp_trig_new_product: "New product created",
    sp_trig_new_arrival: "New arrival received",
    sp_trig_featured: "Product marked Featured",
    sp_trig_on_sale: "Product placed on Sale",
    sp_trig_promotion: "Promotion created",
    sp_trig_back_in_stock: "Back in stock",
    sp_trig_seasonal: "Seasonal product",
    sp_tab_reviews: "Reviews",
    sp_rev_title: "Customer Review Showcase",
    sp_rev_desc: "Turn 5-star customer feedback into ready-made Facebook post drafts — review them in History before publishing.",
    sp_rev_filter_5: "5★ only",
    sp_rev_filter_4: "4★ & up",
    sp_rev_create_draft: "Create Post Draft",
    sp_rev_drafted: "Drafted",
    sp_rev_empty: "No customer reviews yet. Reviews arrive when shoppers rate completed online orders.",
    sp_rev_no_comment: "No written comment — rating only.",
    sp_rev_anonymous: "Customer",
    sp_rev_draft_created: "Draft created — check the History tab",
    sp_rev_auto_title: "Auto-draft 5-star reviews",
    sp_rev_auto_desc: "New 5-star reviews with a comment automatically become Facebook post drafts (never published without your approval).",
    sp_bestseller_title: "Weekly best-seller draft",
    sp_bestseller_desc: "Every week the top-selling product automatically becomes a ready-made post draft, so the page stays active without effort.",
    sp_bestseller_now: "Draft best-seller post now",
    sp_autosync_title: "Auto Sync Meta Catalog",
    sp_autosync_desc: "Price, stock, name, image and availability changes update the Meta Catalog automatically. Catalog syncing never creates social posts.",
    sp_simulation_title: "Simulation Mode (no real posting)",
    sp_simulation_desc: "Test every workflow safely — posts and catalog syncs get simulated Meta IDs and nothing is sent to Meta.",
    sp_save_settings: "Save Social Settings",
    sp_drip_legacy: "Product Drip Queue (legacy auto-post)",
    sp_pp_title: "Select Products",
    sp_pp_search_ph: "Search by name, SKU or barcode…",
    sp_pp_all_categories: "All categories",
    sp_pp_no_products: "No products found",
    sp_pp_stock: "Stock",
    sp_pp_service: "Service",
    sp_pp_use: "Use",
    sp_pp_products_word: "product(s)",
    sp_t_settings_saved: "Social settings saved",
    sp_t_published: "Published ✓",
    sp_t_scheduled: "Post scheduled ✓",
    sp_t_failed: "Publishing failed",
    sp_t_need_content: "Write a caption or add a photo first",
    sp_open_post: "Open post",
    sp_fix_in_settings: "Fix in Social Settings",
    sp_t_publishing: "Publishing…",
    sp_t_publishing_hint: "Meta is fetching your media — this can take up to a minute. Keep this tab open.",
    sp_t_still_publishing: "Still publishing in the background — the result will appear in History in a minute",
    sp_t_select_first: "Select a product first",
    sp_t_upload_failed: "Image upload failed",
    sp_duplicate_title: "Duplicate post",
    sp_story_duplicate_title: "Duplicate story",
    sp_pick_platform: "Pick at least one platform",
    sp_partial: "Partial success — check results below",
  },
  ar: {
    // General
    store_name: "بست فور لس",
    store_tag: "تسوق",
    sign_in: "تسجيل الدخول",
    signing_in: "جاري تسجيل الدخول...",
    welcome_back: "مرحبا بعودتك",
    enter_credentials: "أدخل رقم الموظف ورمز الدخول للمتابعة.",
    staff_number: "رقم الموظف",
    access_code: "رمز الدخول",
    ask_manager: "اطلب بيانات الدخول من المدير",
    logout: "تسجيل خروج",
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
    edit: "تعديل",
    create: "إنشاء",
    update: "تحديث",
    search: "بحث",
    loading: "جاري التحميل...",
    load_failed_title: "تعذّر تحميل البيانات — سجلاتك آمنة، الخادم لم يستجب.",
    inv_load_failed: "تعذّر تحميل المنتجات — بياناتك آمنة، الخادم لم يستجب.",
    saving: "جاري الحفظ...",
    done: "تم",
    back: "رجوع",
    add: "إضافة",
    remove: "إزالة",
    close: "إغلاق",
    confirm: "تأكيد",
    yes: "نعم",
    no: "لا",
    actions: "إجراءات",
    active: "نشط",
    inactive: "غير نشط",
    all: "الكل",
    none: "لا شيء",
    // Nav
    // Stock source picker (wholesale / mixed carton)
    ss_title: "من أين يأتي هذا المخزون؟",
    ss_desc: "بيع جملة / كرتونة مختلطة — سيتم خصم كل الأصناف من الموقع الذي تختاره. المطلوب / المتوفر لكل منتج.",
    ss_store: "مخزون المحل",
    ss_warehouse: "مخزون المستودع",
    ss_no_location: "لا يوجد موقع من هذا النوع في هذا الفرع",
    ss_short: "ناقص",
    ss_not_enough: "المخزون غير كافٍ في",
    ss_need: "المطلوب",
    ss_available: "المتوفر",
    ss_hint_change: "اختر الموقع الآخر أو عدّل الكميات في السلة.",
    ss_back: "الرجوع إلى السلة",
    ss_use: "استخدم",
    ss_select: "اختر المصدر",
    ss_source: "مصدر المخزون",
    ss_change: "تغيير",
    ss_stock: "مخزون",
    ss_cartons: "كرتونة",
    nav_dashboard: "لوحة التحكم",
    nav_more: "القائمة",
    name: "الاسم",
    wao_auto_sent: "تم إرسال تحديث واتساب للعميل تلقائياً",
    nav_pos: "نقطة البيع",
    nav_inventory: "المخزون",
    nav_shipments: "الشحنات",
    nav_loyalty: "الولاء",
    nav_staff: "الموظفين",
    nav_reports: "التقارير",
    nav_audit: "سجل المراجعة",
    nav_website: "ربط الموقع",
    nav_branding: "العلامة التجارية",
    nav_settings: "الإعدادات",
    light_mode: "الوضع الفاتح",
    dark_mode: "الوضع الداكن",
    pin_sidebar: "تثبيت القائمة",
    auto_hide: "إخفاء تلقائي",
    nav_shop: "المتجر الإلكتروني",
    nav_catalog: "الكتالوج",
    nav_shop_customizer: "تخصيص المتجر",
    nav_orders: "الطلبات",
    nav_returns: "المرتجعات والاستبدال",
    nav_wa_orders: "طلبات واتساب",
    nav_whatsapp: "واتساب",
    nav_coupons: "القسائم",
    nav_social: "التواصل الاجتماعي",
    nav_vendors: "الموردين",
    nav_analytics: "التحليلات",
    nav_stores: "متعدد الفروع",
    nav_messages: "الرسائل",
    // Dashboard
    good_morning: "صباح الخير",
    good_afternoon: "مساء الخير",
    good_evening: "مساء الخير",
    whats_happening: "إليك ما يحدث في المتجر اليوم.",
    todays_revenue: "إيرادات اليوم",
    todays_sales: "مبيعات اليوم",
    total_products: "إجمالي المنتجات",
    low_stock_items: "منتجات منخفضة",
    weekly_revenue: "الإيرادات الأسبوعية",
    recent_sales: "المبيعات الأخيرة",
    no_recent_sales: "لا توجد مبيعات أخيرة",
    no_sales_data: "لا توجد بيانات مبيعات. ابدأ البيع!",
    items: "عناصر",
    item: "عنصر",
    // POS
    cart: "السلة",
    checkout: "الدفع",
    cancel_sale: "إلغاء البيع",
    payment_method: "طريقة الدفع",
    cash: "نقدي",
    card: "بطاقة",
    subtotal: "المجموع الفرعي",
    discount: "الخصم",
    total: "الإجمالي",
    search_products: "ابحث عن منتجات، رمز، أو باركود...",
    out_of_stock: "نفد",
    cart_empty: "السلة فارغة",
    no_products: "لا توجد منتجات",
    link_loyalty: "ربط عميل الولاء",
    sale_completed: "تمت عملية البيع!",
    failed_sale: "فشل في معالجة البيع",
    open_drawer_first: "افتح درج النقد أولاً",
    each: "للقطعة",
    // Cash Drawer
    drawer_open: "مفتوح",
    drawer_closed: "مغلق",
    open_cash_drawer: "فتح درج النقد",
    close_drawer: "إغلاق الدرج",
    drawer_closed_msg: "الدرج مغلق. افتحه لبدء البيع.",
    opening_amount: "مبلغ الافتتاح",
    closing_count: "العد الفعلي",
    expected_balance: "الرصيد المتوقع",
    variance: "الفرق",
    usd_balance: "رصيد الدولار",
    lbp_balance: "رصيد الليرة",
    opened_by: "فتح بواسطة",
    // Cancel Sale
    cancel_sale_title: "إلغاء البيع",
    cancel_sale_desc: "يتطلب إذن المدير أو المالك لإلغاء البيع الحالي.",
    manager_staff_number: "رقم المدير/المالك",
    cancel_confirm: "إلغاء البيع",
    verifying: "جاري التحقق...",
    invalid_credentials: "بيانات غير صحيحة",
    only_managers: "فقط المدراء أو المالكون يمكنهم إلغاء المبيعات",
    // Shift Summary
    shift_summary: "ملخص الوردية",
    total_sales_count: "إجمالي المبيعات",
    cash_sales: "مبيعات نقدية",
    card_sales: "مبيعات بطاقة",
    total_revenue: "إجمالي الإيرادات",
    cash_drawer_breakdown: "تفاصيل درج النقد",
    opening: "الافتتاح",
    sales_added: "+ المبيعات",
    removed: "- المسحوب",
    expected: "المتوقع",
    counted: "المحسوب",
    transactions: "عمليات الدرج",
    // Inventory
    inventory: "المخزون",
    products_count: "منتجات",
    add_product: "إضافة منتج",
    import_csv: "استيراد CSV",
    edit_product: "تعديل المنتج",
    product_name: "اسم المنتج",
    price: "السعر",
    cost_price: "سعر التكلفة",
    category: "الفئة",
    stock: "المخزون",
    barcode: "الباركود",
    sku: "رمز المنتج",
    description: "الوصف",
    low_stock_alert: "تنبيه المخزون المنخفض",
    product_image: "صورة المنتج",
    upload_image: "انقر لرفع صورة",
    paste_url: "أو الصق رابط الصورة",
    in_stock: "متوفر",
    low: "منخفض",
    out: "نفد المخزون",
    deactivate: "إلغاء تفعيل",
    sku_auto: "تلقائي",
    all_categories: "جميع الفئات",
    csv_format: "مثال تنسيق CSV:",
    import_products: "استيراد المنتجات",
    // Staff
    staff_management: "إدارة الموظفين",
    team_members: "أعضاء الفريق",
    edit_staff: "تعديل الموظف",
    full_name: "الاسم الكامل",
    role: "الدور",
    admin: "مدير عام",
    manager: "مدير",
    staff: "موظف",
    new_code: "رمز جديد (اختياري)",
    code_required: "رمز الدخول",
    leave_blank: "اتركه فارغاً للإبقاء على الحالي",
    // Loyalty
    loyalty_program: "برنامج الولاء",
    manage_loyalty: "إدارة العملاء وبطاقات الولاء ونقاط المكافآت",
    add_customer: "إضافة عميل",
    edit_customer: "تعديل العميل",
    total_members: "إجمالي الأعضاء",
    active_points: "النقاط النشطة",
    total_spent: "إجمالي الإيرادات",
    avg_visits: "متوسط الزيارات",
    phone: "الهاتف",
    email: "البريد الإلكتروني",
    loyalty_card: "بطاقة الولاء",
    loyalty_barcode: "باركود بطاقة الولاء",
    barcode_auto: "يُنشأ تلقائياً إذا ترك فارغاً",
    points: "نقاط",
    visits: "زيارات",
    add_to_start: "أضف عملاء لبدء برنامج الولاء",
    how_points_work: "كيف تعمل نقاط الولاء:",
    earn_rule: "يكسب العميل نقطة واحدة مقابل كل $1",
    redeem_rule: "يمكن استبدال النقاط عند الدفع: 100 نقطة = $2 خصم",
    link_at_pos: "اربط العملاء في نقطة البيع لتتبع النقاط تلقائياً",
    redeem: "استبدال",
    points_min: "النقاط (الحد الأدنى 100)",
    no_contact: "لا يوجد تواصل",
    no_card: "لا توجد بطاقة",
    // Reports
    sales_reports: "تقارير المبيعات",
    track_performance: "تتبع أداء متجرك",
    this_week: "هذا الأسبوع",
    this_period: "هذه الفترة",
    revenue_over_time: "الإيرادات عبر الزمن",
    by_category: "حسب الفئة",
    top_selling: "المنتجات الأكثر مبيعاً",
    units_sold: "وحدة مباعة",
    days_7: "7 أيام",
    days_30: "30 يوم",
    days_90: "90 يوم",
    no_data_period: "لا توجد بيانات لهذه الفترة",
    no_category_data: "لا توجد بيانات فئات",
    no_sales_yet: "لا توجد بيانات مبيعات بعد",
    // Messages
    messages: "الرسائل",
    team_communication: "التواصل بين الفريق",
    team_chat: "دردشة الفريق",
    members: "أعضاء",
    no_messages: "لا توجد رسائل بعد. ابدأ محادثة!",
    type_message: "اكتب رسالة...",
    everyone: "الجميع",
    to_everyone: "(للجميع)",
    send: "إرسال",
    // Settings
    settings: "الإعدادات",
    store_config: "إعدادات وإدارة المتجر",
    store_configuration: "إعدادات المتجر",
    store_name_label: "اسم المتجر",
    exchange_rate: "سعر الصرف (1 دولار = ? ليرة)",
    loyalty_rate: "معدل الولاء ($ لكل نقطة)",
    store_logo: "شعار المتجر",
    upload_logo: "رفع شعار جديد",
    save_settings: "حفظ الإعدادات",
    pos_stations: "محطات نقاط البيع",
    station_desc: "يمكن تعيين اسم محطة لكل جهاز. يتم تتبع أدراج النقد لكل محطة.",
    this_device: "هذا الجهاز",
    all_stations: "جميع المحطات",
    set_active: "تعيين كنشط",
    add_station: "إضافة",
    station_placeholder: "مثال: كاشير 2، الكاونتر الأمامي...",
    backup_reset: "النسخ الاحتياطي وإعادة التعيين",
    download_backup: "تحميل نسخة احتياطية كاملة",
    reset_data: "إعادة تعيين البيانات",
    set_reset_pw: "تعيين كلمة مرور إعادة التعيين",
    backup_note: "النسخ الاحتياطية تشمل جميع البيانات. إعادة التعيين تتطلب كلمة مرور المالك.",
    select_reset: "اختر ما تريد إعادة تعيينه. لا يمكن التراجع عن هذا الإجراء.",
    reset_password: "كلمة مرور إعادة التعيين",
    enter_reset_pw: "أدخل كلمة مرور إعادة التعيين",
    reset_selected: "إعادة تعيين المحدد",
    new_reset_pw: "كلمة مرور جديدة",
    owner_pw_desc: "كلمة مرور خاصة بالمالك مطلوبة لإعادة تعيين البيانات.",
    min_4_chars: "4 أحرف كحد أدنى",
    save_password: "حفظ كلمة المرور",
    products_inventory: "المنتجات والمخزون",
    sales_history: "سجل المبيعات",
    customers_loyalty: "العملاء والولاء",
    audit_log: "سجل المراجعة",
    cash_drawer_history: "سجل درج النقد",
    // Audit Log
    audit_log_title: "سجل المراجعة",
    track_changes: "تتبع جميع تغييرات المخزون والنظام",
    all_changes: "جميع التغييرات",
    products_filter: "المنتجات",
    settings_filter: "الإعدادات",
    system_filter: "النظام",
    time: "الوقت",
    action: "الإجراء",
    changes: "التغييرات",
    by: "بواسطة",
    no_audit: "لا توجد سجلات بعد",
    // Website Sync
    website_sync: "ربط الموقع",
    connect_website: "اربط موقعك لمزامنة المنتجات والمخزون والأسعار",
    api_key: "مفتاح API",
    no_key: "لم يتم إنشاء مفتاح API بعد.",
    generate_key: "إنشاء مفتاح API",
    regenerate_key: "إعادة إنشاء المفتاح",
    keep_secret: "حافظ على سرية هذا المفتاح. شاركه فقط مع مطور موقعك.",
    api_endpoints: "نقاط API",
    api_desc: "استخدم هذه النقاط على موقعك لجلب وتحديث بيانات المنتجات.",
    get_products: "جلب جميع المنتجات",
    update_product: "تحديث منتج",
    connection_status: "حالة الاتصال",
    key_active: "مفتاح API نشط - جاهز للاتصال",
    no_key_generated: "لم يتم إنشاء مفتاح API",
    copied: "تم النسخ",
    // Receipt
    sale_complete: "تمت عملية البيع",
    // Dashboard extras
    sales_word: "مبيعات",
    last_7_days: "آخر 7 أيام",
    last_30_days: "آخر 30 يوم",
    avg_sale: "متوسط البيع",
    month_revenue: "إيرادات الشهر",
    per_transaction: "لكل عملية",
    pending_orders: "طلبات معلقة",
    online_orders_waiting: "طلبات أونلاين بانتظار المعالجة",
    online_orders_new_today: "جديدة اليوم",
    online_orders_view: "عرض الطلبات",
    recent_transactions: "المعاملات الأخيرة",
    // Vendors
    vendor_management: "إدارة الموردين",
    nav_customers: "العملاء",
    add_vendor: "إضافة مورد",
    new_po: "أمر شراء جديد",
    purchase_orders: "أوامر الشراء",
    receipts: "إيصالات الاستلام",
    bills: "الفواتير",
    vendors: "الموردون",
    categories: "الفئات",
    receive: "استلام",
    pay: "دفع",
    submit: "إرسال",
    // Reports
    reports: "التقارير",
    reports_sub: "تتبع الأداء وصحة المخزون",
    sales: "المبيعات",
    currency: "العملة",
    variants: "المتغيرات",
    expenses: "المصاريف",
    drawer: "الدرج",
    // Inventory extras
    products: "المنتجات",
    gen_barcodes: "توليد باركود",
    multi_store: "متعدد الفروع",
    // Settings sections
    settings_sub: "إعدادات وإدارة المتجر",
    store_information: "معلومات المتجر",
    currency_pricing: "العملة والتسعير",
    receipt_configuration: "إعدادات الإيصال",
    checkout_rules: "قواعد الدفع",
    role_permissions: "صلاحيات الأدوار",
    alerts_notifications: "التنبيهات والإشعارات",
    security: "الأمان",
    receipt: "الإيصال",
    pdf: "PDF",
    print: "طباعة",
    thank_you: "شكراً لتسوقك!",
    rate: "السعر",
    // Audit/Coupons/Loyalty/Orders/Analytics
    export: "تصدير",
    item_col: "العنصر",
    audit_auto_note: "تُسجَّل الإجراءات مثل المبيعات والتعديلات وتسجيلات الدخول هنا تلقائياً",
    new_coupon: "قسيمة جديدة",
    create_coupon: "إنشاء قسيمة",
    coupon_name_ph: "اسم القسيمة (مثال: خصم عيد ميلاد 10%)",
    type: "النوع",
    value: "القيمة",
    min_purchase: "الحد الأدنى للشراء ($)",
    expiry_days: "الانتهاء (أيام)",
    birthday_coupon: "قسيمة عيد ميلاد",
    no_coupons: "لا توجد قسائم بعد.",
    send_to_customer: "إرسال إلى عميل",
    select_customer: "اختر عميلاً...",
    expires: "تنتهي",
    used: "استُخدمت",
    birthday: "عيد ميلاد",
    activate: "تفعيل",
    bonus_points: "نقاط إضافية",
    activity: "النشاط",
    points_earned_30d: "نقاط مكتسبة (30 يوم)",
    transactions_30d: "معاملات (30 يوم)",
    loyalty_members: "أعضاء الولاء",
    pts_per_usd: "نقاط / $1",
    points_distribution: "توزيع النقاط",
    top_customers_spend: "أفضل العملاء حسب الإنفاق",
    no_customer_data: "لا توجد بيانات عملاء بعد",
    recent_loyalty_tx: "معاملات الولاء الأخيرة",
    no_loyalty_activity: "لا يوجد نشاط ولاء بعد",
    adjust: "تعديل",
    adjust_points: "تعديل النقاط",
    general: "عام",
    enable_loyalty: "تفعيل برنامج الولاء",
    earning_rules: "قواعد الكسب",
    redemption_rules: "قواعد الاستبدال",
    expiration: "انتهاء الصلاحية",
    reason: "السبب",
    orders_word: "طلبات",
    sales_orders: "المبيعات والطلبات",
    export_csv: "تصدير CSV",
    refresh: "تحديث",
    revenue: "الإيرادات",
    on_account: "على الحساب",
    orders_search_ph: "ابحث برقم الفاتورة، العميل، الكاشير...",
    today: "اليوم",
    this_month: "هذا الشهر",
    all_time: "كل الفترات",
    completed: "مكتملة",
    returns: "المرتجعات",
    returned: "مرتجع",
    no_sales_found: "لا توجد مبيعات",
    sales_appear_here: "ستظهر مبيعات نقطة البيع هنا",
    try_different_search: "جرب بحثاً مختلفاً",
    customer: "العميل",
    cashier: "الكاشير",
    payment: "الدفع",
    tax: "الضريبة",
    points_redeemed: "نقاط مستبدلة",
    change_due: "الباقي",
    receipt_pdf: "إيصال PDF",
    return_btn: "إرجاع",
    confirm_return: "تأكيد الإرجاع",
    return_reason_ph: "سبب الإرجاع...",
    advanced_analytics: "التحليلات المتقدمة",
    analytics_sub: "رؤى معمقة حول أداء عملك",
    last_90_days: "آخر 90 يوم",
    last_year: "آخر سنة",
    customer_value: "قيمة العملاء",
    profit_margins: "هوامش الربح",
    staff_performance: "أداء الموظفين",
    sales_trends: "اتجاهات المبيعات",
    cost: "التكلفة",
    profit: "الربح",
    margin: "الهامش",
    // Customers/Staff/Stores/Shop
    customers: "العملاء",
    customers_sub: "إدارة حسابات وأرصدة العملاء",
    balance: "الرصيد",
    add_new: "إضافة جديد",
    staff_sub: "إدارة الفريق والورديات والرواتب",
    clock_in: "تسجيل حضور",
    clock_out: "تسجيل انصراف",
    shifts: "الورديات",
    payroll: "الرواتب",
    stores_sub: "إدارة الفروع ومزامنة المخزون",
    add_store: "إضافة فرع",
    online_shop: "المتجر الإلكتروني",
    view_store: "عرض المتجر",
    orders_tab: "الطلبات",
    language: "اللغة",
    total_customers: "إجمالي العملاء",
    outstanding_balance: "الرصيد المستحق",
    total_points: "إجمالي النقاط",
    customers_search_ph: "ابحث بالاسم، الهاتف، البريد...",
    top_spenders: "الأكثر إنفاقاً",
    most_points: "الأكثر نقاطاً",
    highest_balance: "الأعلى رصيداً",
    recent: "الأحدث",
    account: "الحساب",
    loyalty: "الولاء",
    coupons_tab: "القسائم",
    notes: "ملاحظات",
    no_customers: "لا يوجد عملاء بعد",
    staff_hr_title: "إدارة الموظفين والموارد البشرية",
    add_staff: "إضافة موظف",
    active_staff_lbl: "الموظفون النشطون",
    today_present: "الحاضرون اليوم",
    pending_leave: "إجازات معلقة",
    shifts_month: "ورديات (الشهر)",
    payroll_total: "إجمالي الرواتب",
    leave: "الإجازات",
    clock_lbl: "الحضور",
    store_management: "إدارة الفروع",
    overview: "نظرة عامة",
    details: "التفاصيل",
    staff_lbl: "الموظفون",
    login_welcome: "مرحباً بعودتك",
    login_sub: "اختر حسابك وأدخل الرمز السري",
    login_store_sub: "أدخل معرّف المتجر للمتابعة",
    login_store_title: "إلى أي متجر تريد الدخول؟",
    login_store_hint: "استخدم معرّف المتجر الظاهر عند التسجيل، أو رقم هاتف المتجر المسجّل.",
    login_store_placeholder: "معرّف المتجر أو رقم الهاتف",
    login_store_continue: "متابعة",
    login_store_not_found: "المتجر غير موجود. تحقق من معرّف المتجر أو رقم الهاتف.",
    login_switch_store: "تغيير المتجر",
    select_account: "اختر حسابك",
    loading_users: "جارِ تحميل المستخدمين...",
    no_users: "لا يوجد مستخدمون",
    no_users_created: "لم يتم إنشاء أي حسابات مستخدمين لهذا المتجر.",
    net_conn_problem: "مشكلة في الاتصال. جارٍ إعادة الاتصال…",
    retry: "إعادة المحاولة",
    users_load_failed: "تعذّر تحميل الحسابات — اضغط لإعادة المحاولة",
    net_reconnecting: "انقطع الاتصال — جارٍ إعادة الاتصال…",
    net_details: "التفاصيل",
    net_details_hint: "أحداث الاتصال الأخيرة على هذا الجهاز (الإنترنت ↔ الخادم):",
    net_back_online: "عاد الاتصال",
    net_offline_hint: "البيع يستمر — تتم المزامنة تلقائياً",
    off_cached_catalog: "وضع عدم الاتصال — استخدام الكتالوج المحفوظ",
    prn_warn_paper_out: "طابعة الإيصالات نفد منها الورق",
    prn_warn_offline: "طابعة الإيصالات غير متصلة",
    prn_warn_paper_jam: "انحشار ورق في طابعة الإيصالات",
    prn_warn_door_open: "غطاء طابعة الإيصالات مفتوح",
    prn_warn_no_toner: "نفد الحبر من طابعة الإيصالات",
    prn_warn_error: "طابعة الإيصالات تُبلغ عن خطأ",
    prn_warn_hint: "يمكنك إتمام البيع؛ عالج مشكلة الطابعة ثم أعد طباعة الإيصال.",
    enter_pin_for: "أدخل الرمز السري لـ",
    start_trial: "ابدأ تجربتك المجانية لمدة 14 يوماً",
    // Common deep-pass
    lang_en: "الإنجليزية",
    lang_ar: "العربية",
    on_lbl: "مفعّل",
    off_lbl: "معطّل",
    ok_lbl: "حسناً",
    amount_received: "المبلغ المستلم",
    total_due: "المطلوب",
    total_paid_usd: "المدفوع (بالدولار)",
    remaining_lbl: "المتبقي",
    change_lbl: "الباقي",
    redeem_loyalty: "استبدال نقاط الولاء",
    available_lbl: "متاحة",
    max_lbl: "الأقصى",
    store_credit_lbl: "رصيد المتجر",
    sc_due_after: "المتبقي بعد الرصيد",
    off_badge: "وضع عدم الاتصال",
    off_pending: "بانتظار المزامنة",
    off_synced: "مبيعات تمت مزامنتها",
    off_sync_dropped: "مبيعات تعذّرت مزامنتها (مشكلة بيانات)",
    off_cash_only: "غير متصل — الدفع نقدًا فقط",
    off_no_loyalty: "غير متصل — رصيد المتجر والنقاط غير متاحة",
    off_sale_saved: "تم حفظ البيع دون اتصال — ستتم المزامنة تلقائيًا",
    off_note: "غير متصل — نقدًا فقط، ستتم مزامنة البيع تلقائيًا",
    off_saved_badge: "محفوظ دون اتصال — ستتم المزامنة عند عودة الاتصال",
    sync_now: "مزامنة الآن",
    wa_receipt_sent: "تم إرسال الإيصال عبر واتساب",
    wa_send_receipt: "إرسال الإيصال",
    discount_lbl: "الخصم",
    processing: "جارِ المعالجة...",
    complete_sale: "إتمام البيع",
    print_receipt: "طباعة الإيصال",
    download_pdf: "تحميل PDF",
    usb_print: "طباعة USB",
    new_sale_btn: "بيع جديد",
    points_earned_sfx: "نقطة ولاء مكتسبة",
    points_redeemed_sfx: "نقطة مستبدلة",
    override_by: "تجاوز بموافقة",
    receipt_preview_lbl: "معاينة الإيصال",
    wa_t_tpls_loaded: "قالباً جديداً تم تحميله (عربي وإنجليزي)",
    cfm_delete_product: "حذف المنتج",
    cfm_delete_category: "حذف الفئة",
    cfm_sure_delete: "هل أنت متأكد من حذف",
    cfm_deactivate_vendor: "تعطيل المورد",
    cfm_deactivate: "تعطيل",
    cfm_delete: "حذف",
    cfm_delete_po: "حذف أمر الشراء",
    cfm_cancel_po: "إلغاء أمر الشراء",
    cfm_no_undo: "لا يمكن التراجع عن هذا الإجراء.",
    cfm_delete_store: "حذف المتجر",
    cfm_delete_store_q: "حذف متجر",
    cfm_delete_shift: "حذف الوردية",
    cfm_delete_shift_desc: "هل تريد حذف سجل الوردية هذا؟",
    cfm_remove_option: "إزالة الخيار",
    cfm_remove: "إزالة",
    cfm_generate_variants: "توليد المتغيرات",
    cfm_generate_pre: "توليد",
    cfm_generate_post: "تركيبة متغيرات؟ سيستبدل هذا المتغيرات الحالية.",
    cfm_delete_variant: "حذف المتغير",
    cfm_delete_variant_desc: "هل تريد حذف هذا المتغير؟",
    wa_test_send: "إرسال تجريبي",
    wa_test_title: "أرسل تجربة إلى هاتفك",
    wa_test_desc: "يرسل هذا القالب إلى واتساب الخاص بك ببيانات تجريبية، تماماً كما يستقبله العملاء.",
    wa_test_phone_ph: "رقم هاتفك (مثال +961 70 123 456)",
    wa_t_test_sent: "أُرسلت رسالة التجربة إلى",
    wa_t_phone_req: "أدخل رقم هاتفك",
    t_sale_lbl: "فاتورة",
    t_completed_lbl: "اكتملت!",
    t_sale_failed: "فشلت عملية البيع",
    t_printer_connected: "تم توصيل الطابعة الحرارية",
    t_printer_connect_failed: "فشل توصيل الطابعة",
    t_printer_disconnected: "تم فصل الطابعة",
    t_printer_not_connected: "الطابعة غير متصلة",
    t_receipt_printed: "تمت طباعة الإيصال",
    t_print_failed: "فشلت الطباعة",
    t_pdf_failed: "فشل تحميل PDF",
    copied_clipboard: "تم النسخ إلى الحافظة",
    day_mon: "الاثنين", day_tue: "الثلاثاء", day_wed: "الأربعاء", day_thu: "الخميس", day_fri: "الجمعة", day_sat: "السبت", day_sun: "الأحد",
    // WhatsApp page
    wa_tab_templates: "القوالب",
    wa_tab_send: "إرسال رسالة",
    wa_tab_bulk: "إرسال جماعي",
    wa_tab_groups: "المجموعات",
    wa_tab_contacts: "جهات الاتصال",
    wa_tab_inbox: "الوارد",
    wa_tab_autoreply: "الرد التلقائي",
    wa_tab_optouts: "إلغاء الاشتراك",
    wa_tab_history: "السجل",
    wa_tab_campaigns: "الحملات",
    wa_tab_settings: "الإعدادات",
    wa_banner_cloud: "إرسال مباشر عبر واتساب Cloud API",
    wa_banner_link: "وضع الرابط — تُفتح الرسائل في واتساب. اربط Cloud API من الإعدادات للإرسال المباشر.",
    wa_new_template: "قالب جديد",
    wa_load_defaults: "تحميل القوالب الافتراضية",
    wa_tpl_name_ph: "اسم القالب",
    wa_tpl_body_ph: "نص الرسالة. استخدم {name}, {points}, {balance}, {store_name} للتخصيص",
    wa_placeholders: "المتغيرات:",
    wa_no_templates: 'لا توجد قوالب بعد. اضغط "تحميل القوالب الافتراضية" للبدء بقوالب عربية وإنجليزية.',
    wa_cat_general: "عام",
    wa_cat_birthday: "عيد ميلاد",
    wa_cat_promotion: "عرض ترويجي",
    wa_cat_loyalty: "ولاء",
    wa_send_to_customer: "إرسال إلى عميل",
    wa_select_customer: "اختر العميل...",
    wa_use_template: "استخدام قالب (اختياري)...",
    wa_custom_msg_ph: "أو اكتب رسالة مخصصة...",
    wa_send_via: "إرسال عبر واتساب",
    wa_open_wa: "فتح واتساب",
    wa_bulk_title: "إرسال جماعي للعملاء",
    wa_select_template: "اختر القالب...",
    wa_filter_all: "جميع العملاء",
    wa_filter_loyalty: "أعضاء الولاء (لديهم نقاط)",
    wa_filter_high: "كبار المنفقين (+100$)",
    wa_filter_bday: "أعياد ميلاد اليوم",
    wa_schedule_label: "جدولة لوقت لاحق (اختياري)",
    wa_schedule_clear: "إلغاء الجدولة (إرسال الآن)",
    wa_optout_note: "العملاء الملغى اشتراكهم مستبعدون دائماً.",
    wa_optout_note_stop: ' تُضاف ملاحظة "أرسل STOP لإلغاء الاشتراك" لكل بث.',
    wa_schedule_broadcast: "جدولة البث",
    wa_start_broadcast: "بدء البث",
    wa_send_all: "إرسال للجميع",
    wa_conversations: "المحادثات",
    wa_no_replies: "لا توجد ردود بعد. ردود العملاء على واتساب تظهر هنا بعد تهيئة الـ webhooks (تبويب الإعدادات).",
    wa_select_conv: "اختر محادثة",
    wa_no_msgs: "لا توجد رسائل في هذه المحادثة.",
    wa_reply_ph: "اكتب رداً...",
    wa_reply_hint: "اربط واتساب Cloud API من الإعدادات للرد من هنا.",
    wa_ar_title: "قواعد الرد التلقائي",
    wa_ar_desc: "عندما تحتوي رسالة العميل على إحدى الكلمات المفتاحية، يُرسل الرد تلقائياً عبر Cloud API. يتطلب ربط Cloud API والـ webhook (تبويب الإعدادات). أوامر STOP/START لها الأولوية دائماً.",
    wa_ar_keywords_ph: "كلمات مفتاحية مفصولة بفواصل (مثال: hours, open, دوام)",
    wa_ar_reply_ph: "رسالة الرد التلقائي...",
    wa_ar_add: "إضافة قاعدة",
    wa_ar_seed: "إضافة أمثلة",
    wa_ar_none: "لا توجد قواعد رد تلقائي بعد. أضف واحدة أعلاه أو حمّل الأمثلة.",
    wa_matched: "تطابقت",
    wa_times: "مرة",
    wa_optouts_title: "إلغاء اشتراك البث",
    wa_optouts_desc: "العملاء الملغى اشتراكهم مستبعدون من جميع رسائل البث الجماعي. عندما يرد العميل بـ STOP على واتساب، حدده كملغى اشتراكه هنا.",
    wa_opted_out_count: "عميل ألغى اشتراكه.",
    wa_no_customers: "لا يوجد عملاء بأرقام هواتف بعد.",
    wa_opted_out: "ملغى الاشتراك",
    wa_subscribed: "مشترك",
    wa_no_messages: "لم تُرسل أي رسائل بعد.",
    wa_read: "قُرئت",
    wa_delivered: "وصلت",
    wa_weekly_title: "عروض أسبوعية تلقائية",
    wa_weekly_desc: "أرسل قالباً تلقائياً كل أسبوع — دون إعادة جدولة. يتطلب ربط Cloud API.",
    wa_rec_filter_loyalty: "أعضاء الولاء",
    wa_rec_filter_high: "كبار المنفقين",
    wa_create_weekly: "إنشاء عرض أسبوعي",
    wa_every: "كل",
    wa_last_sent: "آخر إرسال",
    wa_no_campaigns: "لا توجد حملات بعد.",
    wa_scheduled_for: "مجدول في",
    wa_recipients: "مستلم",
    wa_sent_lbl: "أُرسلت",
    wa_failed_lbl: "فشلت",
    wa_filter_lbl: "التصفية:",
    wa_connected_title: "واتساب Cloud API متصل",
    wa_phone_id_lbl: "معرّف رقم الهاتف:",
    wa_quality_lbl: "الجودة:",
    wa_disconnect: "قطع الاتصال",
    wa_connect_title: "ربط Meta WhatsApp Cloud API",
    wa_connect_desc: "أرسل الرسائل مباشرة من النظام — دون فتح تبويبات wa.me. احصل على بياناتك من developers.facebook.com ← تطبيقك ← WhatsApp ← API Setup: انسخ معرّف رقم الهاتف (Phone Number ID وليس رقم الهاتف نفسه) ورمز وصول دائم (يُنصح برمز System User).",
    wa_update_creds: "تحديث البيانات",
    wa_creds: "بيانات الاعتماد",
    wa_phone_id_ph: "معرّف رقم الهاتف (مثال 106540352242922)",
    wa_token_ph: "رمز الوصول",
    wa_verifying: "جارِ التحقق...",
    wa_connect_verify: "ربط وتحقق",
    wa_creds_note: "يتم التحقق من البيانات لدى Meta قبل الحفظ وتُخزن مشفرة.",
    wa_test_conn: "اختبار الاتصال",
    wa_testing: "جارٍ الاختبار...",
    wa_test_ok: "اتصال WhatsApp ناجح",
    wa_test_fail: "فشل اختبار الاتصال",
    wa_verified_name: "الاسم المعتمد",
    wa_display_phone: "رقم الهاتف",
    wa_acct_status: "حالة الحساب",
    wa_quality: "تقييم الجودة",
    wa_msg_limit: "حد الرسائل",
    wa_platform: "المنصة",
    wa_name_status: "حالة الاسم",
    wa_code_verif: "التحقق من الرمز",
    wa_register_title: "تسجيل الرقم على Cloud API",
    wa_register_desc: "إذا فشل الإرسال بخطأ Meta ‏#133010 (الحساب غير مسجّل)، سجّل رقمك هنا باستخدام رمز PIN المكوَّن من 6 أرقام للتحقق بخطوتين.",
    wa_fb_title: "قالب بديل لنافذة الـ 24 ساعة",
    wa_fb_desc: "يحظر واتساب الرسائل النصية الحرة بعد مرور أكثر من 24 ساعة على آخر رد من العميل (خطأ Meta ‏#131047). اختر قالبًا معتمدًا من Meta أدناه — عند اصطدام الإرسال بهذا الحد، يرسل التطبيق القالب تلقائيًا بدلًا منه لتصل رسالتك.",
    wa_fb_current: "القالب البديل الفعّال:",
    wa_fb_not_set: "لم يتم تعيين قالب بديل — سيفشل الإرسال للعملاء الذين لم يردّوا خلال آخر 24 ساعة.",
    wa_fb_load: "تحميل القوالب المعتمدة",
    wa_fb_waba_ph: "معرّف WABA (فقط إذا فشل الاكتشاف التلقائي)",
    wa_fb_none_opt: "بدون قالب بديل (معطّل)",
    wa_fb_save: "حفظ القالب البديل",
    wa_fb_saved: "تم حفظ القالب البديل",
    wa_fb_save_failed: "تعذّر حفظ القالب البديل",
    wa_fb_load_failed: "تعذّر تحميل القوالب من Meta",
    wa_fb_none_found: "لا توجد قوالب معتمدة في حسابك على واتساب. أنشئ قالبًا في Meta WhatsApp Manager أولًا.",
    wa_fb_too_many_vars: "(متغيرات كثيرة جدًا)",
    wa_fb_vars_hint: "{{1}} = اسم العميل · {{2}} = اسم المتجر",
    wa_tpl_badge: "قالب",
    wa_mt_title: "قوالب Meta الرسمية",
    wa_mt_desc: "هذه قوالب واتساب الحقيقية التي تراجعها Meta. القوالب المعتمدة تُرسل في أي وقت — حتى خارج نافذة الـ 24 ساعة. أنشئ قالبًا أدناه وأرسله للاعتماد دون مغادرة التطبيق.",
    wa_mt_name_ph: "template_name (أحرف صغيرة وشرطات سفلية)",
    wa_mt_body_ph: "نص القالب… استخدم {{1}} لاسم العميل و{{2}} لاسم المتجر",
    wa_mt_submit: "إرسال للاعتماد",
    wa_mt_submitted: "تم إرسال القالب إلى Meta",
    wa_mt_failed: "فشل إجراء قالب Meta",
    wa_mt_deleted: "تم حذف القالب",
    wa_mt_none: "لا توجد قوالب Meta بعد — أنشئ أول قالب أعلاه.",
    wa_mt_req: "أدخل اسم القالب ونصه",
    wa_mt_cat_marketing: "تسويق (عروض وترويج)",
    wa_mt_cat_utility: "خدمي (تحديثات الطلبات)",
    wa_mt_vars_hint: "يستغرق الاعتماد عادةً من دقائق إلى بضع ساعات. {{1}} = اسم العميل، {{2}} = اسم المتجر.",
    wa_mt_presets: "قوالب جاهزة — اضغط للتعبئة ثم أرسل للاعتماد:",
    wa_retry_failed: "إعادة إرسال الفاشلة",
    wa_retry_ok: "تمت إعادة جدولة الرسائل الفاشلة",
    wa_retry_failed_err: "تعذّرت إعادة المحاولة",
    wa_window_open: "نافذة النص الحر مفتوحة",
    wa_window_closed: "النافذة مغلقة — سيُستخدم القالب المعتمد",
    wa_media_sent: "تم إرسال الوسائط",
    wa_media_failed: "تعذّر إرسال الوسائط",
    wa_document: "مستند",
    wa_qr_title: "الردود السريعة",
    wa_qr_none: "لا توجد ردود سريعة بعد — احفظ أول ردّ أدناه (ساعات العمل، رسوم التوصيل…).",
    wa_qr_title_ph: "العنوان",
    wa_qr_text_ph: "نص الرد… ({name} = العميل)",
    wa_qr_add: "حفظ",
    wa_qr_saved: "تم حفظ الرد السريع",
    wa_qr_req: "أدخل العنوان والنص",
    wa_qr_failed: "فشل إجراء الرد السريع",
    wa_start_order: "بدء طلب",
    wa_order_cust_created: "تم إنشاء عميل من هذه المحادثة",
    wa_order_cust_linked: "تم الربط بعميل موجود",
    wa_order_failed: "تعذّر بدء الطلب",
    wa_greet_title: "ترحيب أول تواصل",
    wa_greet_desc: "رحّب تلقائيًا بأي رقم يراسل متجرك لأول مرة. يدعم {name} و{store_name}. عند إرسال الترحيب، تُتخطى الردود التلقائية بالكلمات المفتاحية لتلك الرسالة الأولى.",
    wa_greet_ph: "مرحبًا {name}! أهلًا بك في {store_name} — كيف نساعدك اليوم؟",
    wa_greet_save: "حفظ رسالة الترحيب",
    wa_greet_saved: "تم حفظ رسالة الترحيب",
    wa_away_title: "الرد التلقائي خارج أوقات العمل",
    wa_away_desc: "خارج ساعات العمل، يتلقى العملاء الذين يراسلونك رسالة تلقائية \"سنرد عليك قريبًا\" (مرة واحدة كحد أقصى لكل محادثة كل 6 ساعات). رسالة الترحيب والردود بالكلمات المفتاحية لها الأولوية.",
    wa_away_open: "مفتوح من",
    wa_away_ph: "شكرًا لرسالتك! نحن مغلقون حاليًا — سنرد عليك فور فتح المتجر. 🕐",
    wa_away_saved: "تم حفظ رسالة الغياب",
    wa_away_save: "حفظ رسالة الغياب",
    wa_notes_title: "ملاحظات داخلية",
    wa_notes_desc: "ملاحظات خاصة لفريقك فقط — لا يراها العميل أبدًا.",
    wa_notes_ph: "أضف ملاحظة خاصة…",
    wa_rcpt_send: "إرسال إيصال PDF إلى هذه المحادثة",
    wa_rcpt_sent: "تم إرسال الإيصال إلى المحادثة",
    wa_rcpt_failed: "تعذر إرسال الإيصال",
    wa_tk_autorenew: "التجديد التلقائي للرمز",
    wa_tk_on: "مفعّل",
    wa_tk_off: "غير مفعّل",
    wa_tk_permanent: "دائم — لا ينتهي أبدًا",
    wa_tk_renew_now: "جدّد الآن",
    wa_tk_expires: "ينتهي الرمز",
    wa_tk_renewed: "آخر تجديد تلقائي",
    wa_tk_renewed_ok: "تم تجديد الرمز — 60 يومًا جديدة",
    wa_tk_still_valid: "الرمز صالح — لا حاجة للتجديد بعد",
    wa_tk_reauth: "الرمز منتهي/ملغى — الصق رمزًا جديدًا في الإعدادات (لا يمكن تجديد الرموز المنتهية)",
    wa_tk_renew_failed: "فشل التجديد",
    wa_tk_setup_hint: "للتجديد التلقائي، أضف Meta App ID و App Secret في الإعدادات ← التواصل الاجتماعي — أو أنشئ رمز System User دائمًا من Meta Business Manager (لا ينتهي أبدًا).",
    wa_cust_panel: "العميل",
    wa_cust_none: "لا يوجد سجل عميل مطابق لهذا الرقم بعد — اضغط بدء طلب لإنشائه.",
    wa_cust_spent: "إجمالي الإنفاق",
    wa_cust_points: "النقاط",
    wa_cust_credit: "رصيد المتجر:",
    wa_cust_recent: "الطلبات الأخيرة",
    wa_cust_no_orders: "لا توجد طلبات بعد",
    wa_cust_online: "أونلاين",
    wa_grp_title: "مجموعات البث",
    wa_grp_desc: "أنشئ قوائم جمهور من أي أرقام هواتف — حتى الأشخاص الذين لم يراسلوك أبدًا — وأرسل لهم العروض. واتساب لا يوصل الرسائل للأرقام الجديدة إلا عبر قالب Meta معتمد (هذا هو خطأ #131047 «Re-engagement» الذي رأيته)، لذلك ترسل المجموعات قوالبك المعتمدة. يمكن للمستلمين الرد بـ STOP في أي وقت لإلغاء الاشتراك تلقائيًا.",
    wa_grp_name_ph: "اسم مجموعة جديدة…",
    wa_grp_name_req: "أدخل اسم المجموعة",
    wa_grp_created: "تم إنشاء المجموعة",
    wa_grp_deleted: "تم حذف المجموعة",
    wa_grp_none: "لا توجد مجموعات بعد — أنشئ أول جمهور أعلاه.",
    wa_grp_select: "اختر أو أنشئ مجموعة لإدارة الأعضاء وإرسال العروض",
    wa_grp_members: "عضو",
    wa_grp_opted_out: "ألغوا الاشتراك",
    wa_grp_entries_ph: "الصق أرقام الهواتف — رقم في كل سطر:\n+96170123456\n+96171234567, سارة\n70345678",
    wa_grp_entries_req: "الصق رقم هاتف واحد على الأقل",
    wa_grp_add_btn: "إضافة الأرقام",
    wa_grp_import_cust: "إضافة كل العملاء",
    wa_grp_import_file: "استيراد CSV/Excel",
    wa_grp_file_failed: "تعذّر استيراد هذا الملف",
    wa_grp_added: "أُضيف",
    wa_grp_invalid: "غير صالح",
    wa_grp_dup: "مكرر",
    wa_grp_in: "مشترك",
    wa_grp_out: "ملغى",
    wa_grp_send_title: "إرسال عرض لهذه المجموعة",
    wa_grp_mode_tpl: "قالب معتمد (يصل للجميع)",
    wa_grp_mode_text: "نص حر (نافذة 24 ساعة فقط)",
    wa_grp_tpl_hint: "قوالب Meta المعتمدة تُسلَّم لجميع الأعضاء — حتى الأرقام التي لم تراسلك أبدًا. {{1}} يُملأ باسم العضو و{{2}} باسم متجرك.",
    wa_grp_text_hint: "النص الحر يصل فقط للأعضاء الذين راسلوك خلال آخر 24 ساعة — والباقي يفشل بخطأ Meta ‏#131047. استخدم قالبًا معتمدًا للوصول للمجموعة كاملة.",
    wa_grp_no_tpl: "لا توجد قوالب معتمدة بعد — أنشئ واحدًا في تبويب القوالب وانتظر اعتماد Meta.",
    wa_grp_pick_tpl: "اختر قالبًا معتمدًا…",
    wa_grp_msg_ph: "عرضك… ({name} = اسم العضو، {store_name} = المتجر)",
    wa_grp_msg_req: "اكتب رسالة",
    wa_grp_sent: "بدأ البث",
    wa_grp_send_btn: "إرسال للمجموعة",
    wa_grp_stop_note: "الأعضاء الذين يردّون بـ STOP يُلغى اشتراكهم تلقائيًا ويُتخطَّون في الإرسالات القادمة. تابع التقدم في تبويب الحملات.",
    wa_grp_reality: "ملاحظة: هذه قوائم بث داخل نظامك — لا يتيح Cloud API من Meta إنشاء أو إدارة مجموعات واتساب حقيقية. يمكنك حفظ رابط دعوة المجموعة أدناه للرجوع إليه.",
    wa_grp_invite_ph: "اختياري: الصق رابط دعوة مجموعة واتساب (تُدار من هاتفك)",
    wa_grp_invite_saved: "تم حفظ رابط الدعوة",
    wa_grp_invite_open: "فتح",
    wa_search_conv: "ابحث في المحادثات…",
    wa_new_chat: "محادثة جديدة",
    wa_filter_unread: "غير مقروء",
    wa_filter_archived: "مؤرشف",
    wa_pin: "تثبيت المحادثة",
    wa_archive: "أرشفة المحادثة",
    wa_reply_to: "الرد على هذه الرسالة",
    wa_mic_start: "تسجيل رسالة صوتية",
    wa_mic_stop: "إيقاف وإرسال",
    wa_mic_denied: "تم رفض الوصول للميكروفون — اسمح به من إعدادات المتصفح أو أرفق ملفًا صوتيًا",
    wa_nc_name_ph: "الاسم (اختياري)",
    wa_nc_save_lbl: "حفظ كعميل جديد في دليلي",
    wa_nc_existing: "عملاء موجودون مطابقون — اضغط لفتح محادثتهم:",
    wa_nc_open: "فتح المحادثة",
    wa_nc_note: "فتح المحادثة لا يرسل أي شيء أبدًا. الرسائل الأولى للأرقام التي لم تراسلك تتطلب قالبًا معتمدًا (قاعدة Meta).",
    wa_nc_failed: "تعذّر فتح المحادثة",
    wa_nc_phone_req: "أدخل رقم الهاتف",
    wa_ct_title: "دليل جهات الاتصال",
    wa_ct_desc: "كل العملاء الذين لديهم رقم هاتف، مباشرة من وحدة العملاء (نفس السجلات — التعديلات متزامنة). يُخزَّن في قاعدة بيانات نظامك وليس في دفتر هاتفك.",
    wa_ct_search_ph: "ابحث بالاسم أو الرقم…",
    wa_ct_chat: "محادثة",
    wa_ct_none: "لا يوجد عملاء بأرقام هواتف بعد — أضف عميلًا من صفحة العملاء أو عبر محادثة جديدة.",
    wa_ct_name_ph: "اسم العميل…",
    wa_ct_name_req: "أدخل الاسم أولًا",
    wa_cust_save: "حفظ كعميل",
    wa_cust_link: "ربط الرقم بالعميل المحدد",
    wa_cust_link_pick: "ربط بعميل موجود…",
    wa_cust_linked_ok: "تم ربط الرقم بالعميل",
    wa_dg_title: "تشخيص الاتصال",
    wa_dg_run: "تشغيل التشخيص",
    wa_dg_hint: "يفحص حالة بيانات الاعتماد والأذونات ونشاط الويب هوك — دون كشف التوكن.",
    wa_dg_number: "الرقم",
    wa_dg_token: "توكن الوصول",
    wa_dg_valid: "صالح",
    wa_dg_invalid: "غير صالح / منتهي",
    wa_dg_token_fix: "أنشئ توكن دائمًا جديدًا في إعدادات Meta Business (مستخدم نظام) واحفظه في «بيانات الاعتماد» أدناه — إعداداتك الحالية لا تُحذف تلقائيًا أبدًا.",
    wa_dg_perms: "الأذونات",
    wa_dg_webhook: "آخر حدث ويب هوك",
    wa_dg_webhook_never: "لم يصل أي حدث ويب هوك بعد — نجاح فحص الـ API لا يثبت وصول الرسائل الواردة؛ اطلب من أحد مراسلة رقمك للتحقق.",
    wa_dg_not_resolved: "لم يُحدَّد بعد",
    wa_dg_note: "يُتحقق من الإرسال والاستقبال بشكل منفصل: التوكن = قدرة الإرسال، الويب هوك = الاستقبال.",
    wa_dg_coex: "التعايش مع تطبيق الهاتف: يستمر تطبيق واتساب للأعمال بالعمل مع الـ API إذا أُضيف الرقم بوضع التعايش — لا توفر Meta طريقة للتحقق من ذلك عن بُعد.",
    wa_dg_groups: "مجموعات واتساب: غير مدعومة في Cloud API — تبويب المجموعات يوفر قوائم بث بدلًا منها.",
    wa_dg_failed: "فشل التشخيص",
    wa_register_pin_ph: "رمز PIN من 6 أرقام",
    wa_register_btn: "تسجيل الرقم",
    wa_registering: "جارٍ التسجيل...",
    wa_registered_ok: "تم تسجيل الرقم على Cloud API بنجاح",
    wa_register_failed: "فشل التسجيل",
    wa_register_pin_invalid: "أدخل رمز PIN المكوَّن من 6 أرقام",
    wa_webhook_title: "Webhooks — إيصالات التسليم وإلغاء الاشتراك التلقائي",
    wa_webhook_desc: "هيّئ هذا الـ webhook في تطبيق Meta الخاص بك (WhatsApp ← Configuration ← Webhooks) واشترك في حقل messages. سترى بعدها إيصالات التسليم/القراءة في السجل، وردود العملاء في تبويب الوارد، ويُلغى اشتراك العملاء الذين يردون بـ STOP تلقائياً (START يعيد الاشتراك).",
    wa_callback_url: "رابط الاستدعاء",
    wa_verify_token: "رمز التحقق",
    wa_t_keywords_req: "الكلمات المفتاحية والرد مطلوبان",
    wa_t_rule_added: "تمت إضافة قاعدة الرد التلقائي",
    wa_t_add_failed: "فشل في إضافة القاعدة",
    wa_t_update_failed: "فشل التحديث",
    wa_t_delete_failed: "فشل الحذف",
    wa_t_rule_deleted: "تم حذف القاعدة",
    wa_t_examples_failed: "فشل في إضافة الأمثلة",
    wa_t_select_template: "اختر قالباً",
    wa_t_weekly_created: "تم إنشاء العرض الأسبوعي التلقائي",
    wa_t_create_failed: "فشل الإنشاء",
    wa_t_weekly_deleted: "تم حذف العرض الأسبوعي",
    wa_t_name_body_req: "الاسم ونص الرسالة مطلوبان",
    wa_t_tpl_updated: "تم تحديث القالب",
    wa_t_tpl_created: "تم إنشاء القالب",
    wa_t_tpl_save_failed: "فشل حفظ القالب",
    wa_t_tpl_deleted: "تم حذف القالب",
    wa_t_select_customer: "اختر عميلاً",
    wa_t_select_tpl_or_msg: "اختر قالباً أو اكتب رسالة",
    wa_t_sent_to: "أُرسلت الرسالة إلى",
    wa_t_wa_opened: "تم فتح واتساب",
    wa_t_send_failed: "فشل الإرسال",
    wa_t_broadcast_scheduled: "تمت جدولة البث في",
    wa_t_customers_word: "عميل",
    wa_t_broadcast_started: "بدأ البث — جارِ الإرسال إلى",
    wa_t_msgs_prepared: "رسالة جاهزة",
    wa_t_failed: "فشل",
    wa_t_cancel_failed: "فشل الإلغاء",
    wa_t_broadcast_cancelled: "تم إلغاء البث المجدول",
    wa_t_creds_req: "معرّف رقم الهاتف ورمز الوصول مطلوبان",
    wa_t_connected: "تم الاتصال:",
    wa_t_verify_failed: "فشل التحقق",
    wa_t_disconnected: "تم قطع اتصال واتساب Cloud API",
    wa_t_disconnect_failed: "فشل قطع الاتصال",
    wa_t_opted_out_sfx: "ألغى اشتراكه في البث",
    wa_t_resub_sfx: "أعاد الاشتراك",
    wa_t_conv_failed: "تعذر تحميل المحادثة",
    wa_t_reply_failed: "فشل إرسال الرد",
    // Social page
    soc_title: "وسائل التواصل الاجتماعي",
    soc_subtitle: "اربط حساباتك الاجتماعية لإدارة حضورك على الإنترنت",
    soc_secure_title: "اتصال آمن",
    soc_secure_desc: "ستسجل الدخول مباشرة عبر الموقع الرسمي لكل منصة. نحن لا نرى ولا نخزن كلمة مرور حساباتك أبداً. يُحفظ فقط الوصول الذي تمنحه أنت، مشفراً بالكامل.",
    soc_connected: "متصل",
    soc_disconnected: "غير متصل",
    soc_needs_reconnect: "يحتاج إعادة ربط",
    soc_token_expired: "انتهت صلاحية الرمز",
    soc_not_connected: "غير متصل",
    soc_connected_by: "ربطه",
    soc_expired_warning: "انتهت صلاحية رمز الوصول. يرجى إعادة الربط لمتابعة إدارة هذا الحساب.",
    soc_reconnect: "إعادة ربط",
    soc_disconnect: "قطع الاتصال",
    soc_connecting: "جارِ الاتصال...",
    soc_connect: "ربط",
    soc_create_post: "إنشاء منشور",
    soc_product_to_post: "منتج إلى منشور",
    soc_post_ph: "اكتب عرضك أو إعلانك...",
    soc_img_ph: "رابط الصورة (اختياري — مطلوب لإنستغرام)",
    soc_publish: "نشر",
    soc_recent_posts: "أحدث المنشورات",
    soc_no_posts: "لا توجد منشورات بعد. انشر عرضك الأول أعلاه!",
    soc_comments: "تعليق",
    soc_view: "عرض",
    soc_no_comments: "لا توجد تعليقات بعد.",
    soc_no_text: "(بدون نص)",
    soc_conn_status: "حالة الاتصال",
    soc_pick_product_desc: "اختر منتجاً — سنجهز العرض بصورته وسعره.",
    soc_search_products: "ابحث عن المنتجات...",
    soc_no_products: "لا توجد منتجات.",
    soc_setup_needed: "مطلوب إعداد",
    soc_not_configured: "لم يتم إعداد ربط وسائل التواصل الاجتماعي لهذا المتجر بعد.",
    soc_contact_admin: "يرجى التواصل مع مدير المتجر لتفعيل ربط فيسبوك وإنستغرام. بعد التهيئة، ستتمكن من ربط حساباتك بنقرة واحدة.",
    soc_t_connected: "تم الربط",
    soc_t_conn_failed: "فشل الاتصال. حاول مرة أخرى.",
    soc_t_start_failed: "تعذر بدء الاتصال. حاول مرة أخرى.",
    soc_disconnect_desc: "يمكنك إعادة الربط في أي وقت. لن يؤثر هذا على منشوراتك الحالية.",
    soc_t_disconnected: "تم قطع الاتصال",
    soc_t_disc_failed: "فشل قطع الاتصال",
    soc_t_select_platform: "اختر منصة متصلة واحدة على الأقل",
    soc_t_write_msg: "اكتب رسالة أو أضف صورة",
    soc_t_ig_img: "منشورات إنستغرام تتطلب رابط صورة",
    soc_t_posted: "تم النشر على",
    soc_t_publish_failed: "فشل نشر المنشور",
    soc_t_comments_failed: "تعذر تحميل التعليقات",
    soc_t_products_failed: "تعذر تحميل المنتجات",
    soc_t_offer_drafted: "تم تجهيز عرض لـ",
    // Branding page
    brand_title: "هوية المتجر",
    brand_subtitle: "خصص ألوان متجرك وشعاره وهويته",
    brand_save: "حفظ التغييرات",
    brand_logo: "شعار المتجر",
    brand_remove: "إزالة",
    brand_drag: "اسحب وأفلت شعارك أو",
    brand_browse: "تصفح",
    brand_logo_hint: "PNG أو JPG حتى 2MB. يُنصح بمقاس 200x200 بكسل.",
    ai_digest_title: "الملخص اليومي الذكي",
    ai_digest_hint: "احصل على ملخص ذكي لأداء اليوم في عشر ثوانٍ.",
    ai_digest_btn: "إنشاء الملخص",
    ai_digest_busy: "جارٍ التفكير...",
    ai_insights_title: "مساعد التحليلات الذكي",
    ai_insights_empty: "اسألني أي شيء عن مبيعاتك وأرباحك ومخزونك وطلباتك.",
    ai_insights_ph: "مثال: ما الأكثر مبيعاً هذا الأسبوع؟",
    ai_new_chat: "محادثة جديدة",
    ai_error: "الذكاء الاصطناعي غير متاح حالياً. حاول مرة أخرى.",
    ai_caption_btn: "إعادة كتابة المنشور بالذكاء الاصطناعي",
    ai_caption_saved: "تم حفظ منشور الذكاء الاصطناعي لهذا المنتج",
    brand_hero: "صورة واجهة المتجر",
    brand_hero_hint: "تظهر أعلى متجرك الإلكتروني. PNG أو JPG حتى 5MB — الصور العريضة (1600 بكسل+) هي الأفضل.",
    brand_hero_uploaded: "تم رفع صورة الواجهة",
    brand_hero_remove: "إزالة — استخدام الصورة الافتراضية",
    brand_theme: "السمة",
    brand_primary: "الأساسي",
    brand_accent: "الثانوي",
    brand_live_preview: "معاينة مباشرة",
    brand_primary_btn: "زر أساسي",
    brand_outline: "محدد",
    brand_badge: "شارة",
    brand_active_nav: "تبويب نشط",
    brand_tagline: "الشعار النصي",
    brand_tagline_ph: "وجهتك الأولى للهدايا المميزة",
    brand_company: "معلومات الشركة",
    brand_company_desc: "تظهر على الإيصالات والفواتير وملفات PDF",
    brand_address: "العنوان",
    brand_phone: "الهاتف",
    brand_email: "البريد الإلكتروني",
    brand_tax: "الرقم الضريبي",
    brand_receipt_footer: "تذييل الإيصال",
    brand_receipt_opts: "خيارات عرض الإيصال",
    brand_show_logo: "إظهار الشعار",
    brand_show_address: "إظهار العنوان",
    brand_show_phone: "إظهار الهاتف",
    brand_show_tax: "إظهار الرقم الضريبي",
    brand_sidebar_preview: "معاينة القائمة الجانبية",
    brand_receipt_preview: "معاينة الإيصال",
    brand_t_saved: "تم حفظ الهوية ومعلومات الشركة!",
    brand_t_save_failed: "فشل الحفظ",
    brand_t_logo_uploaded: "تم رفع الشعار!",
    brand_t_logo_failed: "فشل رفع الشعار",
    // WhatsApp Orders page
    wao_title: "طلبات واتساب",
    wao_total: "إجمالي",
    wao_today: "اليوم",
    wao_pending: "معلق",
    wao_confirmed: "مؤكد",
    wao_ready: "جاهز",
    wao_completed: "مكتمل",
    wao_cancelled: "ملغى",
    wao_revenue: "الإيرادات",
    wao_search_ph: "ابحث بالاسم أو الهاتف أو رقم الطلب...",
    wao_all_orders: "جميع الطلبات",
    wao_no_orders: "لا توجد طلبات واتساب",
    wao_with_status: "بحالة",
    wao_hint: "الطلبات عبر المتجر الإلكتروني ستظهر هنا",
    wao_delivery: "توصيل",
    wao_items_word: "أصناف",
    wao_confirm: "تأكيد",
    wao_mark_ready: "جاهز للاستلام",
    wao_complete: "إكمال",
    wao_no_phone: "لا يوجد هاتف",
    wao_order_items: "أصناف الطلب",
    wao_customer_note: "ملاحظة العميل:",
    wao_chat: "محادثة واتساب",
    wao_copy_tracking: "نسخ رابط التتبع",
    wao_ready_photo: "صورة الطلب الجاهز",
    wao_upload_photo: "أضف صورة للطلب الجاهز",
    wao_replace_photo: "استبدال",
    wao_remove_photo: "إزالة",
    wao_photo_hint: "تُرسل للعميل مع رسالة واتساب \"جاهز\".",
    wao_photo_added: "تمت إضافة الصورة",
    wao_photo_removed: "تمت إزالة الصورة",
    wao_photo_invalid: "الرجاء اختيار ملف صورة",
    wao_photo_too_big: "يجب أن تكون الصورة أقل من 8 ميغابايت",
    ap_title: "نشر المنتجات تلقائياً",
    ap_desc: "انشر مخزونك تلقائياً على فيسبوك وإنستغرام مع الصورة والسعر (دولار + ل.ل) ورابط المتجر.",
    ap_auto_new: "نشر المنتجات الجديدة تلقائياً",
    ap_auto_new_hint: "كل منتج يُضاف إلى المخزون يدخل قائمة الانتظار ويُنشر تلقائياً",
    ap_queue_all: "نشر كل المنتجات",
    ap_queue_all_title: "نشر كل المنتجات؟",
    ap_queue_all_desc: "ستدخل جميع المنتجات النشطة قائمة الانتظار وتُنشر تدريجياً (منتج كل 30 دقيقة) على فيسبوك وإنستغرام. المنتجات المنشورة سابقاً يتم تخطيها.",
    ap_post_next: "انشر التالي الآن",
    ap_pause: "إيقاف مؤقت",
    ap_resume: "استئناف",
    ap_clear: "مسح القائمة",
    ap_clear_title: "مسح قائمة الانتظار؟",
    ap_clear_desc: "ستتم إزالة جميع المنتجات المعلقة (غير المنشورة بعد) من القائمة.",
    ap_queued: "بالانتظار",
    ap_posted: "منشور",
    ap_failed: "فشل",
    ap_retry: "إعادة المحاولة",
    ap_remove: "إزالة",
    ap_paused_note: "القائمة متوقفة مؤقتاً — لن يُنشر شيء حتى الاستئناف.",
    ap_pace_note: "يُنشر منتج واحد كل {n} دقيقة للبقاء ضمن حدود ميتا (~50 منشور إنستغرام يومياً). المنتجات بدون صورة تُنشر نصاً فقط على فيسبوك وتُتخطى على إنستغرام.",
    ap_connect_first: "اربط فيسبوك أو إنستغرام أعلاه لبدء النشر.",
    ap_t_saved: "تم الحفظ",
    ap_t_failed: "فشلت العملية",
    ap_t_queued: "منتج في قائمة الانتظار",
    ap_t_skipped: "تم تخطيها (منشورة/بالانتظار)",
    ap_t_posted: "تم النشر",
    ap_t_requeued: "أُعيدت للقائمة",
    ap_t_cleared: "أُزيلت من القائمة",
    ap_hours_title: "ساعات النشر",
    ap_hours_hint: "انشر فقط عندما يكون جمهورك مستيقظاً",
    ap_hours_any: "أي وقت",
    ap_hours_outside: "خارج الفترة — بالانتظار",
    ap_preview: "معاينة المنشور",
    ap_preview_title: "معاينة المنشور",
    ap_preview_no_image: "لا توجد صورة للمنتج — سيُنشر نصاً فقط على فيسبوك ويُتخطى على إنستغرام",
    ap_preview_no_base: "حدّد رابط متجرك في الإعدادات ← المتجر الإلكتروني لتظهر الصور ورابط المتجر في المنشورات.",
    wao_sale_created: "سُجّل كعملية بيع",
    wao_each: "للواحد",
    wao_coupon: "خصم الكوبون",
    wao_loyalty: "خصم الولاء",
    wao_delivery_fee: "رسوم التوصيل",
    wao_tax: "الضريبة",
    wao_return_refund: "إرجاع واسترداد",
    wao_return_order: "إرجاع هذا الطلب؟",
    wao_return_q: "ستُعاد جميع المنتجات إلى المخزون وتُعكس عملية البيع:",
    wao_returned: "مُرجع",
    wao_refunded: "مسترد",
    wao_notif_history: "سجل الإشعارات",
    wao_via: "عبر",
    wao_admin_notes: "ملاحظات الإدارة",
    wao_notes_ph: "ملاحظات داخلية...",
    wao_just_now: "الآن",
    wao_cancel_order: "إلغاء الطلب",
    wao_cancel_q: "إلغاء الطلب",
    wao_t_notes_saved: "تم حفظ الملاحظات",
    wao_t_tracking_copied: "تم نسخ رابط التتبع!",
    wao_t_wa_opened: "تم فتح واتساب — اضغط إرسال لإشعار العميل",
    // Social & Meta Commerce (sp_)
    sp_title: "التواصل الاجتماعي وتجارة ميتا",
    sp_subtitle: "انشر على فيسبوك وإنستغرام وزامن مخزونك مع كتالوج ميتا",
    sp_tab_facebook: "فيسبوك",
    sp_tab_all: "كل القنوات",
    sp_all_title: "انشر على كل القنوات",
    sp_all_publish: "انشر في كل مكان",
    sp_all_pick_channel: "اختر قناة واحدة على الأقل",
    sp_all_ig_needs_photo: "إنستغرام يحتاج صورة — أضف صورة أو ألغِ اختيار إنستغرام",
    sp_all_partial: "قنوات نُشرت — راجع النتائج أدناه",
    sp_all_wa_confirm_title: "إرسال إلى عملاء واتساب؟",
    sp_all_wa_confirm_desc: "سيتم إرسال رسالة لكل عميل مشترك على واتساب الآن. متابعة؟",
    sp_view_post: "عرض",
    sp_tab_analytics: "التحليلات",
    sp_analytics_title: "أداء القنوات",
    sp_analytics_sub: "الإعجابات والتعليقات والوصول لكل قناة جنبًا إلى جنب",
    sp_analytics_demo_note: "بعض الأرقام تجريبية (منشورات وضع المحاكاة).",
    sp_top_performer: "الأفضل أداءً",
    sp_posts: "منشورات",
    sp_avg_engagement: "متوسط التفاعل",
    sp_likes: "إعجابات",
    sp_comments: "تعليقات",
    sp_shares: "مشاركات",
    sp_best_hour: "أفضل ساعة",
    sp_from_posts: "من منشوراتك",
    sp_suggested_default: "مقترح",
    sp_top_post: "أفضل منشور",
    sp_no_posts_yet: "لا توجد منشورات على هذه القناة بعد.",
    sp_apply_best_time: "تطبيق",
    sp_tab_instagram: "إنستغرام",
    sp_tab_stories: "القصص",
    sp_tab_catalog: "كتالوج ميتا",
    sp_tab_planner: "المخطِّط",
    sp_tab_history: "السجل",
    sp_tab_settings: "إعدادات التواصل",
    sp_sim_mode: "وضع المحاكاة",
    sp_connected: "متصل",
    sp_off: "غير متصل",
    sp_select_products: "اختر المنتجات",
    sp_select_product: "اختر منتجاً",
    sp_fb_post: "منشور فيسبوك",
    sp_ig_post: "منشور إنستغرام",
    sp_story_24h: "قصة (24 ساعة)",
    sp_headline_ph: "عنوان المنشور (اختياري)",
    sp_caption_ph: "النص — اكتبه بنفسك أو أنشئه بالذكاء الاصطناعي ثم عدّله بحرية…",
    sp_ig_caption_ph: "النص + الوسوم — أنشئه بالذكاء الاصطناعي ثم عدّله بحرية…",
    sp_link_ph: "رابط المتجر / المنتج (يستخدم نطاق متجرك العام)",
    sp_video_ph: "رابط فيديو اختياري (HTTPS عام — تُحمّله ميتا)",
    sp_ig_video_ph: "رابط فيديو / ريلز (HTTPS عام) — يتجاوز الصور المحددة",
    sp_story_video_ph: "رابط فيديو (HTTPS عام، 60 ثانية كحد أقصى، يُفضّل 9:16) — يتجاوز الصورة",
    sp_images_label: "الصور (اختر واحدة لمنشور صورة، أو عدة صور لمنشور متعدد)",
    sp_media_required_label: "الوسائط",
    sp_required: "*مطلوب",
    sp_ig_media_hint: "— صورة واحدة، أو 2-10 لألبوم، أو رابط فيديو/ريلز",
    sp_story_media_hint: "— صورة واحدة (يُفضّل 9:16) أو رابط فيديو",
    sp_upload: "رفع",
    sp_no_images_hint: "لا توجد صور منتجات بعد — اختر منتجاً أو ارفع صورة تسويقية.",
    sp_schedule_optional: "جدولة (اختياري)",
    sp_your_tz: "(المنطقة الزمنية لمتجرك)",
    sp_clear: "مسح",
    sp_publish_now: "انشر الآن",
    sp_schedule_post: "جدولة المنشور",
    sp_publish_story: "انشر القصة",
    sp_schedule: "جدولة",
    sp_preview: "معاينة",
    sp_story_preview: "معاينة القصة",
    sp_916_preview: "معاينة 9:16",
    sp_stories_expire: "تختفي القصص بعد 24 ساعة",
    sp_ig_no_media: "يتطلب إنستغرام صورة أو فيديو. الرجاء اختيار وسائط قبل النشر.",
    sp_story_no_media: "تحتاج القصة إلى صورة أو فيديو.",
    sp_fb_story: "قصة فيسبوك",
    sp_ig_story: "قصة إنستغرام",
    sp_ai_style: "الأسلوب",
    sp_ai_language: "اللغة",
    sp_ai_cta: "دعوة لاتخاذ إجراء",
    sp_ai_model: "نموذج الذكاء",
    sp_generate_fb_ai: "أنشئ منشور فيسبوك بالذكاء الاصطناعي",
    sp_generate_ig_ai: "أنشئ منشور إنستغرام بالذكاء الاصطناعي",
    sp_style_professional: "احترافي",
    sp_style_friendly: "ودّي",
    sp_style_sales: "تركيز على المبيعات",
    sp_style_new_arrival: "وصل حديثاً",
    sp_style_premium: "فاخر",
    sp_style_seasonal: "موسمي",
    sp_style_promotional: "ترويجي",
    sp_style_short: "قصير",
    sp_style_detailed: "مفصّل",
    sp_lang_en: "الإنجليزية",
    sp_lang_ar: "العربية",
    sp_lang_both: "إنجليزي + عربي",
    sp_cta_shop: "تسوّق أونلاين",
    sp_cta_whatsapp: "اطلب عبر واتساب",
    sp_cta_visit: "زُر المتجر",
    sp_cta_message: "أرسل رسالة",
    sp_cta_learn: "اعرف المزيد",
    sp_cta_none: "بدون دعوة",
    sp_cat_title: "كتالوج ميتا",
    sp_cat_configured: "مُهيّأ",
    sp_cat_not_configured: "غير مُهيّأ",
    sp_cat_no_id: "لا يوجد معرّف كتالوج — أضفه في إعدادات التواصل",
    sp_cat_id: "معرّف الكتالوج",
    sp_cat_synced: "مُزامن",
    sp_cat_failed: "فشل",
    sp_cat_autosync: "مزامنة تلقائية",
    sp_cat_lastsync: "آخر مزامنة",
    sp_cat_sync_all: "زامن كل المنتجات",
    sp_cat_sync_selected: "زامن منتجات محددة",
    sp_cat_publish_new: "انشر المنتجات الجديدة",
    sp_cat_update_existing: "حدّث الموجودة",
    sp_cat_retry_failed: "أعد محاولة الفاشلة",
    sp_cat_history: "سجل مزامنة الكتالوج",
    sp_cat_no_activity: "لا يوجد نشاط للكتالوج بعد",
    sp_cat_syncing: "جارٍ المزامنة…",
    sp_cat_products: "منتجات",
    sp_all: "الكل",
    sp_retry: "أعد المحاولة",
    sp_all_platforms: "كل المنصات",
    sp_all_statuses: "كل الحالات",
    sp_st_published: "منشور",
    sp_st_failed: "فشل",
    sp_st_scheduled: "مجدول",
    sp_st_pending: "بانتظار الموافقة",
    sp_st_publishing: "جارٍ النشر…",
    sp_st_draft: "مسودة",
    sp_st_drafts: "المسودات",
    sp_st_rejected: "مرفوض",
    sp_st_cancelled: "ملغى",
    sp_refresh_insights: "حدّث الإحصاءات",
    sp_top_products: "المنتجات الأفضل أداءً",
    sp_demo_numbers: "أرقام تجريبية",
    sp_reach: "وصول",
    sp_demo: "تجريبي",
    sp_auto: "تلقائي",
    sp_by: "بواسطة",
    sp_publishes: "يُنشر",
    sp_simulated: "محاكاة",
    sp_story_badge: "قصة",
    sp_approve: "موافقة",
    sp_now: "الآن",
    sp_publish: "انشر",
    sp_edit_post: "تعديل المنشور",
    sp_headline: "العنوان",
    sp_reschedule_optional: "إعادة جدولة (اختياري)",
    sp_save: "حفظ",
    sp_cancel: "إلغاء",
    sp_recent_fb: "أحدث المنشورات (مباشرة من فيسبوك)",
    sp_load: "تحميل",
    sp_no_posts: "لا توجد منشورات بعد — انشر من تبويب فيسبوك أو إنستغرام",
    sp_no_recent: "لا توجد منشورات حديثة للصفحة",
    sp_fb_not_connected: "فيسبوك غير متصل",
    sp_no_text: "(بدون نص)",
    sp_planner_title: "مخطِّط المنشورات الأسبوعي",
    sp_planner_desc: "يقترح الذكاء الاصطناعي منشوراً واحداً يومياً من أحدث منتجاتك. لا يُنشر شيء حتى توافق.",
    sp_planner_platform: "المنصة",
    sp_planner_days: "الأيام",
    sp_planner_time: "وقت النشر",
    sp_planner_alternate: "بالتناوب فيسبوك/إنستغرام",
    sp_planner_fb_only: "فيسبوك فقط",
    sp_planner_ig_only: "إنستغرام فقط",
    sp_days_suffix: "أيام",
    sp_include_story: "أضف قصة منتج يومية أيضاً",
    sp_generate_week: "أنشئ أسبوعاً من المنشورات بالذكاء الاصطناعي",
    sp_generating: "جارٍ الإنشاء…",
    sp_posts_word: "منشورات",
    sp_last_run: "آخر تشغيل",
    sp_proposed_suffix: "مقترح",
    sp_skipped_suffix: "متخطى",
    sp_awaiting_approval: "منشورات مقترحة بانتظار الموافقة",
    sp_approve_all: "وافق على الأسبوع كاملاً",
    sp_no_proposed: "لا توجد منشورات مقترحة — أنشئ أسبوعاً أعلاه",
    sp_appearing: "ستظهر المنشورات هنا أثناء كتابة الذكاء الاصطناعي لها…",
    sp_planner_tip: "نصيحة: عدّل أي منشور مقترح من تبويب السجل قبل الموافقة.",
    sp_best_time: "أفضل وقت للنشر",
    sp_use_hour: "استخدم هذه الساعة",
    sp_best_time_more_a: "استناداً إلى",
    sp_best_time_more_b: "منشورات حتى الآن — انشر أكثر (وحدّث الإحصاءات) لتوصية أقوى.",
    sp_conn_fb: "فيسبوك",
    sp_conn_ig: "إنستغرام",
    sp_conn_catalog: "كتالوج ميتا",
    sp_not_set: "غير محدد",
    sp_error: "خطأ",
    sp_test: "اختبار",
    sp_connect: "اتصال",
    sp_verified: "تم التحقق",
    sp_not_connected_short: "غير متصل",
    sp_public_domain_title: "نطاق المتجر العام",
    sp_public_domain_desc: "كل روابط المنتجات في المنشورات والكتالوج تستخدم هذا النطاق (مثال: https://www.yourstore.com).",
    sp_auto_detected: "اكتُشف تلقائياً:",
    sp_meta_creds: "بيانات اعتماد ميتا",
    sp_meta_creds_desc: "الاتصال بالأزرار أعلاه يملأ هذه الحقول تلقائياً. يمكنك أيضاً لصقها يدوياً — يُشفّر الرمز ولا يُعرض مجدداً.",
    sp_page_id_ph: "معرّف صفحة فيسبوك",
    sp_ig_id_ph: "معرّف حساب إنستغرام",
    sp_catalog_id_ph: "معرّف كتالوج ميتا",
    sp_token_ph: "رمز وصول الصفحة",
    sp_token_saved_ph: "رمز وصول الصفحة (محفوظ ✓ — الصق للاستبدال)",
    sp_autopost_fb: "نشر تلقائي على فيسبوك",
    sp_autopost_ig: "نشر تلقائي على إنستغرام",
    sp_ig_autopost_note: "النشر التلقائي على إنستغرام يعمل فقط عند وجود صورة عامة صالحة للمنتج — لا تُنشأ منشورات نصية أبداً.",
    sp_require_approval: "تتطلب الموافقة قبل النشر",
    sp_trig_new_product: "إنشاء منتج جديد",
    sp_trig_new_arrival: "استلام وصول جديد",
    sp_trig_featured: "تمييز المنتج",
    sp_trig_on_sale: "تخفيض سعر المنتج",
    sp_trig_promotion: "إنشاء عرض ترويجي",
    sp_trig_back_in_stock: "عاد للمخزون",
    sp_trig_seasonal: "منتج موسمي",
    sp_tab_reviews: "التقييمات",
    sp_rev_title: "عرض تقييمات الزبائن",
    sp_rev_desc: "حوّل تقييمات 5 نجوم إلى مسودات منشورات فيسبوك جاهزة — راجعها في السجل قبل النشر.",
    sp_rev_filter_5: "5★ فقط",
    sp_rev_filter_4: "4★ فما فوق",
    sp_rev_create_draft: "إنشاء مسودة منشور",
    sp_rev_drafted: "تم إنشاء مسودة",
    sp_rev_empty: "لا توجد تقييمات بعد. تصل التقييمات عندما يقيّم الزبائن طلباتهم المكتملة من المتجر الإلكتروني.",
    sp_rev_no_comment: "بدون تعليق مكتوب — تقييم فقط.",
    sp_rev_anonymous: "زبون",
    sp_rev_draft_created: "تم إنشاء المسودة — راجع تبويب السجل",
    sp_rev_auto_title: "مسودة تلقائية لتقييمات 5 نجوم",
    sp_rev_auto_desc: "التقييمات الجديدة بـ5 نجوم مع تعليق تتحول تلقائياً إلى مسودات منشورات فيسبوك (لا تُنشر أبداً دون موافقتك).",
    sp_bestseller_title: "مسودة الأكثر مبيعاً أسبوعياً",
    sp_bestseller_desc: "كل أسبوع يتحول المنتج الأكثر مبيعاً تلقائياً إلى مسودة منشور جاهزة، لتبقى الصفحة نشطة دون مجهود.",
    sp_bestseller_now: "أنشئ مسودة الأكثر مبيعاً الآن",
    sp_autosync_title: "مزامنة كتالوج ميتا تلقائياً",
    sp_autosync_desc: "تغييرات السعر والمخزون والاسم والصورة والتوفر تُحدّث كتالوج ميتا تلقائياً. مزامنة الكتالوج لا تُنشئ منشورات اجتماعية أبداً.",
    sp_simulation_title: "وضع المحاكاة (بدون نشر حقيقي)",
    sp_simulation_desc: "اختبر كل شيء بأمان — تحصل المنشورات والمزامنات على معرّفات ميتا وهمية ولا يُرسل شيء إلى ميتا.",
    sp_save_settings: "حفظ إعدادات التواصل",
    sp_drip_legacy: "قائمة النشر التدريجي (النظام القديم)",
    sp_pp_title: "اختر المنتجات",
    sp_pp_search_ph: "ابحث بالاسم أو SKU أو الباركود…",
    sp_pp_all_categories: "كل الفئات",
    sp_pp_no_products: "لا توجد منتجات",
    sp_pp_stock: "المخزون",
    sp_pp_service: "خدمة",
    sp_pp_use: "استخدم",
    sp_pp_products_word: "منتج(ات)",
    sp_t_settings_saved: "تم حفظ إعدادات التواصل",
    sp_t_published: "تم النشر ✓",
    sp_t_scheduled: "تمت جدولة المنشور ✓",
    sp_t_failed: "فشل النشر",
    sp_t_need_content: "اكتب تعليقاً أو أضف صورة أولاً",
    sp_open_post: "فتح المنشور",
    sp_fix_in_settings: "أصلح من إعدادات التواصل",
    sp_t_publishing: "جارٍ النشر…",
    sp_t_publishing_hint: "ميتا تحمّل الوسائط — قد يستغرق ذلك حتى دقيقة. أبقِ هذه الصفحة مفتوحة.",
    sp_t_still_publishing: "ما زال النشر جارياً في الخلفية — ستظهر النتيجة في السجل خلال دقيقة",
    sp_t_select_first: "اختر منتجاً أولاً",
    sp_t_upload_failed: "فشل رفع الصورة",
    sp_duplicate_title: "منشور مكرر",
    sp_story_duplicate_title: "قصة مكررة",
    sp_pick_platform: "اختر منصة واحدة على الأقل",
    sp_partial: "نجاح جزئي — راجع النتائج أدناه",
  },
};

Object.assign(translations.en, hrTranslations.en);
Object.assign(translations.ar, hrTranslations.ar);

export default translations;
